import type { Translation } from '../../types';
import type { integrations as en } from '../en/integrations';

export const integrations: Translation<typeof en> = {
  common: {
    loading: 'Đang tải…',
    contextFailed: 'Không tải được cấu hình tích hợp của hệ thống này',
    refresh: 'Làm mới',
    close: 'Đóng',
    cancel: 'Huỷ',
    back: 'Quay lại',
    saving: 'Đang lưu…',
    all: 'Tất cả',
    yes: 'Có',
    no: 'Không',
    on: 'Bật',
    off: 'Tắt',
    newer: 'Mới hơn',
    older: 'Cũ hơn',
    more: 'Xem thêm',
    outsideControlCenter: 'Thiết lập ngoài Control Center',
  },
  env: {
    short: { OTE: 'OT&E', PRODUCTION: 'Chính thức' },
    long: { OTE: 'Máy chủ thử nghiệm (OT&E)', PRODUCTION: 'Máy chủ chính thức (production)' },
    inline: { OTE: 'máy chủ thử nghiệm (OT&E)', PRODUCTION: 'máy chủ chính thức' },
    editing: 'Bạn đang thay đổi cấu hình của máy chủ này: {{env}}',
    approvalRequired: 'Thay đổi ở đây được lưu thành đề xuất. Cần người thứ hai phê duyệt, sau đó mới có người áp dụng; trước đó không có gì thay đổi.',
    immediate: 'Thay đổi ở đây có hiệu lực ngay; các dịch vụ đang chạy nhận thay đổi trong khoảng {{seconds}} giây.',
    oneConfiguration: 'Mỗi máy chủ có một cấu hình duy nhất. Máy chủ còn lại (OT&E hoặc production) có cấu hình riêng, thiết lập trên chính máy chủ đó.',
    deployment: 'Máy chủ này:',
    refresh: 'Các dịch vụ nhận thay đổi trong khoảng {{seconds}} giây.',
    breakGlassTitle: 'Chế độ khẩn cấp: dùng cấu hình trên máy chủ',
    breakGlass:
      'Hệ thống này đang được đặt để bỏ qua cấu hình VNNIC lưu tại đây và dùng giá trị cấu hình trên máy chủ. Các thay đổi lưu tại đây vẫn được giữ, nhưng chỉ có hiệu lực khi tắt chế độ này.',
  },
  deployment: { ote: 'thử nghiệm (OT&E)', production: 'chính thức (production)' },
  presetFill: {
    title: 'Điền sẵn địa chỉ OT&E / production',
    use: { OTE: 'Điền sẵn địa chỉ OT&E', PRODUCTION: 'Điền sẵn địa chỉ production' },
    otherServer: 'Dành cho máy chủ còn lại: máy chủ này đang chạy {{env}}.',
  },
  channel: {
    DIRECT_EPP: 'Trực tiếp với nhà quản lý tên miền (EPP)',
    REGISTRY_REST: 'Trực tiếp qua dịch vụ web (REST) của nhà quản lý tên miền',
    UPSTREAM_REGISTRAR: 'Qua nhà đăng ký trung gian',
  },
  channelShort: { DIRECT_EPP: 'Trực tiếp (EPP)', REGISTRY_REST: 'Trực tiếp (dịch vụ web)', UPSTREAM_REGISTRAR: 'Qua trung gian' },
  channelHint: {
    DIRECT_EPP: 'Tino là nhà đăng ký được công nhận của TLD và tự gửi đăng ký, gia hạn, chuyển nhượng tới nhà quản lý tên miền qua EPP, giao thức chuẩn của ngành.',
    REGISTRY_REST: 'Tino là nhà đăng ký được công nhận của TLD, nhưng nhà quản lý tên miền cung cấp dịch vụ web (REST) riêng thay cho EPP, nên các lệnh đi qua dịch vụ đó.',
    UPSTREAM_REGISTRAR:
      'Tino không đăng ký trực tiếp được TLD này, nên đăng ký qua dịch vụ web của một nhà đăng ký được công nhận khác. Nhà đăng ký đó quản lý các tên miền và được ghi là nhà đăng ký quản lý trong báo cáo gTLD gửi VNNIC.',
  },
  channelGuide: { title: 'Ba cách đăng ký một TLD (kênh đăng ký)' },
  kind: { REGISTRY: 'Nhà quản lý tên miền (registry)', UPSTREAM_REGISTRAR: 'Nhà đăng ký trung gian' },
  kindHint: {
    REGISTRY: 'Tổ chức vận hành tên miền cấp cao (TLD). Tino gửi đăng ký, gia hạn và chuyển nhượng trực tiếp tới tổ chức này.',
    UPSTREAM_REGISTRAR:
      'Một nhà đăng ký được công nhận khác. Tino đăng ký tên miền qua dịch vụ của họ khi không thể đăng ký trực tiếp; nhà đăng ký này trở thành nhà đăng ký quản lý (sponsoring registrar) của các tên miền đó.',
  },
  protocol: { EPP: 'EPP', REST: 'Dịch vụ web (REST)' },
  protocolHint: {
    EPP: 'Giao thức chuẩn của các nhà quản lý tên miền, qua kết nối mã hoá có chứng thư số máy khách.',
    REST: 'Dịch vụ web riêng của nhà cung cấp. Với nhà cung cấp nền tảng đã hỗ trợ (như WebNIC) có thể tự động đăng ký; với nhà cung cấp khác cần có tài liệu kỹ thuật của họ trước.',
  },
  adapter: { 'standard-epp': 'EPP tiêu chuẩn', 'vnnic-epp': 'Cổng EPP của VNNIC', none: 'Chưa có', webnic: 'WebNIC' },
  adapterStatus: {
    AVAILABLE: 'Có thể đăng ký tự động',
    NOT_AVAILABLE_NEEDS_SPECIFICATION: 'Chưa thể đăng ký tự động: cần tài liệu kỹ thuật chính thức của nhà cung cấp',
  },
  adapterNotice: {
    title: 'Chưa thể đăng ký tự động: cần tài liệu kỹ thuật chính thức của nhà cung cấp',
    body: 'Nền tảng lưu và kiểm tra kết nối này, và có thể chọn nó làm kênh cho TLD, nhưng chưa thể gửi đăng ký, gia hạn hay chuyển nhượng qua kết nối này cho đến khi tài liệu kỹ thuật chính thức của nhà cung cấp được lưu trữ và phần tích hợp được xây dựng. Hãy liên hệ nhóm nền tảng để bắt đầu công việc đó.',
  },
  connectionStatus: { ACTIVE: 'Đang hoạt động', SUSPENDED: 'Tạm ngừng', RETIRED: 'Ngừng sử dụng' },
  versionStatus: { PENDING_APPROVAL: 'Chờ phê duyệt', ACTIVE: 'Đang có hiệu lực', SUPERSEDED: 'Đã được thay thế', REJECTED: 'Bị từ chối', CANCELLED: 'Đã huỷ' },
  credentialStatus: { PENDING: 'Chờ phê duyệt', ACTIVE: 'Đang dùng', ROTATED: 'Đã được thay thế', REVOKED: 'Đã thu hồi' },
  approvalStatus: {
    PENDING: 'Chờ người thứ hai',
    APPROVED: 'Đã phê duyệt, sẵn sàng áp dụng',
    REJECTED: 'Bị từ chối',
    EXPIRED: 'Đã hết hạn',
    EXECUTED: 'Đã áp dụng',
    CANCELLED: 'Đã huỷ',
  },
  closedReason: {
    APPROVAL_REJECTED: 'Đã đóng: người phê duyệt từ chối',
    CANCELLED: 'Đã đóng: huỷ trước khi được phê duyệt',
    REVOKED_BY_OPERATOR: 'Bị nhân viên vận hành thu hồi',
  },
  permission: {
    'integration.manage': 'quản lý tích hợp',
    'registry.credential.manage': 'quản lý thông tin đăng nhập',
  },
  authMethod: {
    HTTP_BASIC: 'Tên đăng nhập và mật khẩu',
    BEARER_TOKEN: 'Mã truy cập (token)',
    API_KEY_HEADER: 'Khoá truy cập gửi kèm mỗi yêu cầu',
    OAUTH2_CLIENT_CREDENTIALS: 'Mã ứng dụng và khoá bí mật, đổi lấy mã truy cập ngắn hạn',
    ADAPTER_DEFINED: 'Theo quy định của phần tích hợp nhà cung cấp',
  },
  trafficClass: { INTERACTIVE: 'Thao tác của khách hàng', BACKGROUND: 'Tác vụ nền', POLL: 'Thông báo từ nhà quản lý', DROPCATCH: 'Săn tên miền hết hạn' },
  trafficClassHint: {
    INTERACTIVE: 'Đăng ký, gia hạn và thay đổi do khách hàng và nhân viên thực hiện.',
    BACKGROUND: 'Các việc chạy theo lịch như gia hạn, kiểm tra và đối soát.',
    POLL: 'Đọc hàng đợi thông báo mà nhà quản lý tên miền giữ cho Tino.',
    DROPCATCH: 'Đăng ký tên miền hết hạn ngay khi được giải phóng.',
  },
  tldClass: { VN: '.vn', GTLD: 'Tên miền quốc tế (gTLD)', NEW_GTLD: 'gTLD mới', CCTLD: 'Mã quốc gia', OTHER: 'Khác' },
  source: { CONFIGURED: 'Đã chọn', DEFAULT: 'mặc định' },
  sourceHint: {
    CONFIGURED: 'Được chọn trong Control Center.',
    DEFAULT: 'Chưa chọn: TLD dùng kết nối mặc định của nó.',
  },
  readiness: {
    ADAPTER_AVAILABLE: 'Kết nối này có thể đăng ký tự động',
    ENVIRONMENT_ENABLED: 'Kết nối đang bật',
    ENDPOINT_CONFIGURED: 'Đã có địa chỉ kết nối',
    CREDENTIAL_ACTIVE: 'Có thông tin đăng nhập đang dùng',
    CERTIFICATE_ACTIVE: 'Có chứng thư số đang dùng',
    CERTIFICATE_VALID_30_DAYS: 'Chứng thư số còn hiệu lực ít nhất 30 ngày',
    CAPABILITIES_IN_FORCE: 'Đã ghi nhận quy định của nhà quản lý tên miền',
    SPONSORING_REGISTRAR_KNOWN: 'Đã có nhà đăng ký quản lý cho báo cáo gTLD gửi VNNIC',
  },
  capability: {
    supports_dnssec: 'DNSSEC',
    supports_idn: 'Tên miền tiếng Việt / đa ngữ',
    supports_transfer: 'Chuyển nhượng',
    supports_rgp: 'Thời gian chuộc lại',
    requires_documents: 'Yêu cầu giấy tờ chủ thể',
    max_registration_years: 'Số năm đăng ký tối đa',
    supports_epp: 'EPP',
    supports_contact_objects: 'Đối tượng contact',
    supports_host_objects: 'Đối tượng name server (host)',
    supports_fee_extension: 'Báo phí qua EPP (fee)',
    supports_change_poll: 'Thông báo thay đổi qua poll',
    supports_premium: 'Tên miền cao cấp (premium)',
    supports_restore: 'Khôi phục tên miền',
    requires_local_presence: 'Yêu cầu hiện diện tại địa phương',
    requires_restore_report: 'Khôi phục cần báo cáo (restore report)',
    max_renew_years: 'Số năm gia hạn tối đa',
  },
  secret: {
    configured: 'Đã thiết lập',
    notConfigured: 'Chưa thiết lập',
    destroyed: 'Giá trị đã bị huỷ',
    source: { STORED: 'Lưu mã hoá trong hệ thống', REFERENCE: 'Lấy từ kho bí mật' },
    reference: 'Tham chiếu',
    changed: 'Thay đổi {{when}}',
    changedBy: 'Thay đổi {{when}} bởi {{who}}',
    writeOnly: 'Không bao giờ hiển thị: chỉ cho biết đã thiết lập chưa, lưu ở đâu và ai thay đổi.',
  },
  secretInput: {
    mode: { KEEP: 'Giữ giá trị hiện tại', VALUE: 'Nhập giá trị mới', REFERENCE: 'Dùng kho bí mật' },
    keepHint: 'Giá trị đang dùng được giữ nguyên.',
    valueLabel: 'Giá trị mới',
    valueHint: 'Giá trị được mã hoá khi lưu và không bao giờ hiển thị lại, kể cả với bạn.',
    length_one: '({{count}} ký tự)',
    length_other: '({{count}} ký tự)',
    fileLabel: 'Tệp khoá bí mật',
    fileRead_one: 'Đã đọc {{name}} ({{count}} ký tự). Nội dung không được hiển thị.',
    fileRead_other: 'Đã đọc {{name}} ({{count}} ký tự). Nội dung không được hiển thị.',
    referenceLabel: 'Tham chiếu kho bí mật',
    referenceHint: 'Nơi máy chủ lấy giá trị: bắt đầu bằng file:, vault: hoặc env:.',
    referenceHintProduction: 'Nơi máy chủ lấy giá trị: bắt đầu bằng file: hoặc vault:. Máy chủ chính thức không chấp nhận biến môi trường của máy chủ (env:).',
    envForbidden: 'Máy chủ chính thức không chấp nhận tham chiếu env:. Hãy dùng file: hoặc vault:.',
    vaultMissing: 'Máy chủ này chưa cấu hình vault; hãy kiểm tra các dịch vụ dùng cấu hình này có đọc được giá trị không.',
    referenceFormat: 'Tham chiếu bắt đầu bằng file:, vault: hoặc env:, theo sau là vị trí.',
  },
  form: {
    reason: 'Lý do',
    noteOptional: 'Ghi chú (không bắt buộc)',
    reasonHint: 'Được ghi vào lịch sử thay đổi cùng tên của bạn.',
    optional: 'không bắt buộc',
    range: '{{min}}–{{max}}',
    confirm: 'Tôi đã kiểm tra các giá trị ở trên.',
    confirmTest: 'Tôi đã kiểm tra các giá trị ở trên. Thay đổi có hiệu lực ngay trên {{env}}.',
    confirmProduction: 'Tôi đã kiểm tra các giá trị ở trên và hiểu rằng đây là thay đổi trên MÔI TRƯỜNG CHÍNH THỨC. Thay đổi chỉ có hiệu lực sau khi người thứ hai phê duyệt và được áp dụng.',
    saveNow: 'Lưu và áp dụng',
    submitForApproval: 'Gửi phê duyệt',
  },
  outcome: {
    appliedTitle: 'Đã lưu và có hiệu lực',
    applied: 'Các dịch vụ đang chạy nhận thay đổi trong khoảng {{seconds}} giây.',
    pendingTitle: 'Đã lưu thành đề xuất: đang chờ phê duyệt',
    pending: 'Chưa có gì thay đổi. Cần người thứ hai phê duyệt đề xuất; sau đó có thể áp dụng từ mục “Thay đổi chờ phê duyệt”.',
    approvalMeta: 'Người phê duyệt cần quyền {{permission}}. Yêu cầu hết hạn sau {{hours}} giờ.',
    pendingEnv: 'Máy chủ: {{env}}.',
  },
  warnings: {
    title: 'Vui lòng kiểm tra',
    ADAPTER_NOT_AVAILABLE: 'Chưa thể đăng ký tự động qua kết nối này (cần tài liệu kỹ thuật của nhà cung cấp).',
    CONNECTION_NOT_CONFIGURED: 'Kết nối được chọn chưa bật hoặc chưa sẵn sàng.',
    NO_SPONSORING_REGISTRAR: 'Kết nối này chưa có nhà đăng ký quản lý, nên báo cáo gTLD gửi VNNIC sẽ bỏ qua các tên miền này.',
    DOMAINS_REMAIN_ON_PREVIOUS: 'Các tên miền đã đăng ký vẫn ở lại kết nối đang quản lý chúng.',
    CERTIFICATE_EXPIRES_SOON: 'Chứng thư số hết hạn trong vòng chưa đầy 30 ngày.',
    SESSION_BUDGET_HIGH: 'Số phiên vượt mức VNNIC cho phép với một tài khoản.',
    PLAIN_HTTP: 'Địa chỉ không được mã hoá (http). Chỉ được chấp nhận ngoài máy chủ chính thức.',
    PRIVATE_ADDRESS: 'Địa chỉ thuộc mạng nội bộ.',
    VAULT_NOT_CONFIGURED_HERE: 'Máy chủ này chưa cấu hình vault; các dịch vụ dùng giá trị này phải đọc được nó.',
    SAME_ADDRESS_ALL_ENVIRONMENTS: 'VNNIC mới công bố một địa chỉ duy nhất cho dịch vụ này; máy chủ OT&E và máy chủ chính thức đều dùng địa chỉ đó.',
  },
  errors: {
    failed: 'Không lưu được thay đổi',
    meta: 'Mã {{code}} · yêu cầu {{requestId}}',
    code: {
      VALIDATION_FAILED: 'Một số giá trị cần sửa:',
      REASON_REQUIRED: 'Vui lòng nhập lý do.',
      FORBIDDEN: 'Bạn chưa có quyền cần thiết cho thay đổi này.',
      MFA_REQUIRED: 'Cần phiên đăng nhập có xác thực hai lớp.',
      SELF_APPROVAL: 'Bạn là người đề xuất thay đổi này, nên cần người khác phê duyệt.',
      TOTP_REQUIRED: 'Hãy nhập mã xác thực hiện tại để tự duyệt.',
      TOTP_INVALID: 'Mã xác thực không đúng hoặc đã được dùng. Hãy chờ mã mới rồi nhập lại.',
      NOT_FOUND: 'Mục này không còn tồn tại. Hãy làm mới trang.',
      UNKNOWN_PROVIDER: 'Dịch vụ không xác định.',
      CONCURRENT_MODIFICATION: 'Đã có người thay đổi mục này trong lúc bạn thao tác. Hãy đóng hộp thoại, làm mới và thử lại.',
      PENDING_CHANGE_EXISTS: 'Đã có một thay đổi đang chờ phê duyệt ở đây. Hãy phê duyệt, áp dụng hoặc huỷ nó trước.',
      REQUEST_IN_PROGRESS: 'Yêu cầu giống hệt đang được xử lý. Vui lòng chờ một lát rồi thử lại.',
      CODE_TAKEN: 'Mã này đã được một kết nối khác sử dụng.',
      CONNECTION_RETIRED: 'Kết nối này đã ngừng sử dụng.',
      CONNECTION_IN_USE: 'Vẫn còn TLD dùng kết nối này. Hãy chuyển chúng sang kết nối khác trước.',
      SAME_CONNECTION: 'TLD này đang dùng đúng kết nối đó.',
      NOTHING_TO_CHANGE: 'Không TLD nào trong số đã chọn cần thay đổi.',
      NOT_CONFIGURED: 'Chưa có địa chỉ để sử dụng.',
      ACTIVE_VERSION_NEEDS_CONFIRMATION: 'Hãy xác nhận bạn muốn thu hồi phiên bản đang dùng.',
      ALREADY_REVOKED: 'Phiên bản này đã bị thu hồi.',
      SECRET_IN_USE: 'Giá trị này vẫn được một phiên bản đang dùng hoặc đang chờ phê duyệt sử dụng.',
      ALREADY_DESTROYED: 'Giá trị này đã bị huỷ.',
      SPONSOR_FROM_UPSTREAM: 'Với nhà đăng ký trung gian, hãy sửa thông tin ngay trên trang kết nối.',
      APPROVAL_NOT_APPROVED: 'Thay đổi chưa được phê duyệt.',
      APPROVAL_EXPIRED: 'Yêu cầu phê duyệt đã hết hạn. Hãy đề xuất lại thay đổi.',
      APPROVAL_ALREADY_EXECUTED: 'Thay đổi đã được áp dụng.',
      APPROVAL_STALE: 'Cấu hình đã thay đổi sau đề xuất này nên không thể áp dụng nữa. Hãy huỷ và đề xuất lại.',
      APPROVAL_NOT_OPEN: 'Thay đổi này không còn mở.',
      APPROVAL_NOT_PENDING: 'Thay đổi này không còn chờ quyết định.',
      IDEMPOTENCY_KEY_REUSED: 'Biểu mẫu này đã được gửi với giá trị khác. Hãy đóng hộp thoại và làm lại.',
      UNSUPPORTED_FOR_PROTOCOL: 'Không áp dụng cho loại kết nối này.',
      TEST_MODE_NOT_SUPPORTED: 'Loại kiểm tra này không áp dụng cho loại kết nối này.',
      TEST_RATE_LIMITED: 'Số lần kiểm tra bị giới hạn để bảo vệ nhà quản lý tên miền. Vui lòng thử lại sau {{seconds}} giây.',
      EXERCISE_OTE_ONLY: 'Việc chạy thử nghiệp vụ gửi lệnh thật nên chỉ chạy trên máy chủ thử nghiệm (OT&E).',
      EXERCISE_EPP_ONLY: 'Chạy thử nghiệp vụ chỉ dùng cho kết nối EPP.',
      EXERCISE_IN_PROGRESS: 'Đang có một lượt chạy cho kết nối này. Hãy chờ lượt đó xong.',
      EXERCISE_RATE_LIMITED: 'Số lượt chạy bị giới hạn để bảo vệ nhà quản lý tên miền. Vui lòng thử lại sau {{seconds}} giây.',
      NO_TEST_ZONE: 'Kết nối này không phục vụ đuôi tên miền nào trên OT&E nên không có tên miền thử để dùng.',
      REGISTRIES_UNAVAILABLE: 'Máy chủ này không kết nối được tới nhà quản lý tên miền.',
      LOGIN_NEEDS_ENDPOINT_IN_FORCE: 'Kiểm tra đăng nhập dùng tài khoản đã lưu nên chỉ chạy với địa chỉ đang áp dụng. Hãy kiểm tra địa chỉ đang đề xuất bằng “Kết nối, mã hoá và lời chào”.',
      USE_INTEGRATION_ENDPOINTS: 'Thay đổi tích hợp được đề xuất tại các trang cấu hình tích hợp, không phải tại trang phê duyệt chung.',
      NOT_SUPPORTED: 'Không áp dụng cho kết nối này.',
      AUTH_FAILED: 'WebNIC từ chối đăng nhập.',
      UNAVAILABLE: 'Không kết nối được tới WebNIC. Vui lòng thử lại sau.',
      PKCS12_INVALID: 'Đây không phải tệp .p12 / .pfx đọc được, hoặc tệp được bảo vệ theo cách nền tảng chưa hỗ trợ. Hãy xuất lại tệp từ công cụ đã tạo ra nó.',
      PKCS12_TOO_LARGE: 'Tệp lớn hơn 64 KB. Tệp chứng thư máy khách thường chỉ vài KB; hãy kiểm tra lại tệp đã chọn.',
      PKCS12_BAD_PASSPHRASE: 'Mật khẩu không mở được tệp này. Hãy nhập lại; đó là mật khẩu được đặt khi xuất tệp.',
      PKCS12_NO_KEY_OR_CERT: 'Tệp phải chứa khoá bí mật và chứng thư cấp cho khoá đó. Hãy xuất chứng thư kèm khoá bí mật (và chuỗi chứng thư).',
      PKCS12_UNSUPPORTED_KEY: 'Loại khoá trong tệp không được chấp nhận. Hãy dùng khoá RSA hoặc khoá ECDSA P-256 / P-384.',
      PKCS12_KEY_TOO_SMALL: 'Khoá RSA trong tệp ngắn hơn 2048 bit nên không còn được chấp nhận. Hãy xin cấp chứng thư mới với khoá mạnh hơn.',
      CERTIFICATE_EXPIRED: 'Chứng thư trong tệp đã hết hạn. Hãy đề nghị nhà quản lý tên miền cấp lại chứng thư.',
      VNNIC_REGISTRAR_API_DISABLED: 'Máy chủ này chưa thiết lập Registrar API của VNNIC.',
      VNNIC_UNAUTHORIZED: 'VNNIC từ chối đăng nhập của Tino (mã khách / khoá bí mật, hoặc địa chỉ máy chủ này chưa có trong danh sách cho phép của VNNIC).',
      VNNIC_REJECTED: 'VNNIC từ chối yêu cầu.',
      GATEWAY_UNAVAILABLE: 'VNNIC không phản hồi. Vui lòng thử lại sau.',
      CERTIFICATE_NOT_YET_VALID: 'Chứng thư trong tệp chưa đến ngày hiệu lực. Hãy tải lên từ ngày bắt đầu hiệu lực, hoặc kiểm tra đồng hồ của máy chủ.',
    },
    field: {
      UNKNOWN_STEP: 'bước không xác định',
      NO_STEP_SELECTED: 'hãy chọn ít nhất một bước',
      REQUIRES_CHECK: 'cần bước kiểm tra tên miền',
      REQUIRES_CONTACTS: 'cần bước tạo liên hệ',
      REQUIRES_CREATE: 'cần bước đăng ký',
      REQUIRED: 'bắt buộc',
      INVALID_CODE: 'dùng 2–32 chữ thường, chữ số hoặc dấu gạch ngang',
      INVALID_HOST: 'không phải tên máy hoặc địa chỉ hợp lệ',
      INVALID_PORT: 'phải từ 1 đến 65535',
      INVALID_URL: 'địa chỉ không hợp lệ',
      HTTPS_REQUIRED: 'máy chủ chính thức cần địa chỉ được mã hoá (https)',
      URL_CREDENTIALS_FORBIDDEN: 'không được chứa tên đăng nhập hoặc mật khẩu',
      URL_QUERY_FORBIDDEN: 'không được chứa tham số sau “?” hoặc “#”',
      OUT_OF_RANGE: 'nằm ngoài phạm vi cho phép',
      TLS_REQUIRED_IN_PRODUCTION: 'kết nối chính thức bắt buộc được mã hoá',
      INVALID_PEM: 'không phải nội dung chứng thư hợp lệ',
      KEY_PASSWORD_REQUIRED: 'khoá bí mật này có mật khẩu; hãy nhập mật khẩu của khoá',
      KEY_PASSWORD_WRONG: 'mật khẩu không mở được khoá bí mật này',
      KEY_PASSWORD_ONLY_FOR_VALUE: 'chỉ nhập mật khẩu khi tải lên hoặc dán khoá; khoá dùng tham chiếu phải không có mật khẩu',
      KEY_ENCRYPTION_UNSUPPORTED: 'kiểu mã hoá khoá này chưa được hỗ trợ; hãy chuyển khoá sang PKCS#8 (openssl pkcs8 -topk8 -v2 aes-256-cbc)',
      ADDRESS_NOT_ALLOWED: 'không được phép dùng địa chỉ này',
      WRONG_PROTOCOL_SECTION: 'không khớp với loại kết nối',
      SECRET_REQUIRED: 'cần có giá trị',
      INVALID_SECRET_REFERENCE: 'không phải tham chiếu kho bí mật hợp lệ',
      DB_REFERENCE_NOT_ALLOWED: 'hãy nhập chính giá trị thay cho loại tham chiếu này',
      ENV_REFERENCE_FORBIDDEN_IN_PRODUCTION: 'máy chủ chính thức không chấp nhận tham chiếu env:',
      SECRET_TOO_LONG: 'giá trị quá dài',
      EPP_PASSWORD_LENGTH: 'mật khẩu phải có 6–16 ký tự',
      NOTHING_TO_KEEP: 'chưa có giá trị hiện tại để giữ',
      CERTIFICATE_EXPIRED: 'chứng thư đã hết hạn',
      CERTIFICATE_NOT_YET_VALID: 'chứng thư chưa đến ngày hiệu lực',
      INVALID_PRIVATE_KEY: 'không phải khoá bí mật hợp lệ',
      KEY_CERTIFICATE_MISMATCH: 'khoá bí mật không thuộc về chứng thư này',
      UPSTREAM_REQUIRES_REST: 'nhà đăng ký trung gian được kết nối qua dịch vụ web',
      ADAPTER_REQUIRED: 'hãy chọn cách kết nối',
      UNKNOWN_ADAPTER: 'chưa có trong phiên bản nền tảng này',
      ADAPTER_KIND_MISMATCH: 'không áp dụng cho loại kết nối này',
      UPSTREAM_IDENTITY_REQUIRED: 'cần thông tin nhà đăng ký trung gian',
      IMMUTABLE: 'không thể thay đổi sau khi tạo',
      UNKNOWN_OPTION: 'thiết lập không xác định',
      INVALID_PATH: 'phải bắt đầu bằng “/”',
      TOO_MANY_TLDS: 'chọn từ 1 đến 500 TLD',
      DUPLICATE_TLD: 'có TLD bị lặp lại',
      UNSUPPORTED_AUTH_METHOD: 'nhà cung cấp này không hỗ trợ cách đăng nhập này',
      UPSTREAM_ONLY: 'chỉ nhà đăng ký trung gian mới có thông tin này',
      UNKNOWN_VERSION: 'phiên bản đó thuộc về cấu hình khác',
      RESERVED_SECRET_REFERENCE: 'tham chiếu này trỏ tới bí mật riêng của nền tảng hoặc tệp hệ thống nên không được dùng',
      INVALID_SITE_KEY: 'chỉ gồm chữ, chữ số, “_” và “-” (tối đa 100 ký tự)',
      TEST_KEY_NOT_ALLOWED: 'khoá dùng thử của Cloudflare không được dùng trên máy chủ chính thức',
    },
  },
  fields: {
    enabled: 'Bật',
    status: 'Trạng thái',
    adapter: 'Phần tích hợp',
    name: 'Tên',
    code: 'Mã',
    kind: 'Loại',
    protocol: 'Cách kết nối',
    connection: 'Kết nối',
    connection_id: 'Kết nối',
    channel: 'Kênh đăng ký',
    client_id: 'Mã đăng nhập / mã ứng dụng',
    secret: 'Mật khẩu hoặc khoá',
    private_key: 'Khoá bí mật',
    certificate_pem: 'Chứng thư số',
    certificate_not_after: 'Chứng thư có hiệu lực đến',
    certificate_subject: 'Chứng thư cấp cho',
    certificate_fingerprint_sha256: 'Dấu vân tay chứng thư (SHA-256)',
    base_version_id: 'Phiên bản làm gốc',
    base_url: 'Địa chỉ',
    iana_id: 'Mã nhà đăng ký IANA',
    trade_name: 'Tên nhà đăng ký',
    legal_name: 'Tên pháp lý',
    api_spec_reference: 'Tài liệu của nhà cung cấp',
    upstream: 'Thông tin nhà đăng ký trung gian',
    upstream_iana_id: 'Mã nhà đăng ký IANA',
    upstream_trade_name: 'Tên nhà đăng ký',
    upstream_legal_name: 'Tên pháp lý',
    tld_ids: 'TLD',
    epp: 'Thiết lập EPP',
    rest: 'Thiết lập dịch vụ web',
    epp_host: 'Địa chỉ máy chủ',
    epp_port: 'Cổng',
    epp_tls: 'Kết nối mã hoá (TLS)',
    epp_server_name: 'Tên trên chứng thư của máy chủ',
    epp_ca_pem: 'Tổ chức cấp chứng thư được tin cậy bổ sung',
    epp_connect_timeout_ms: 'Thời gian chờ kết nối',
    epp_command_timeout_ms: 'Thời gian chờ phản hồi',
    epp_acquire_timeout_ms: 'Thời gian chờ phiên rảnh',
    epp_failure_threshold: 'Số lỗi liên tiếp trước khi tạm dừng',
    epp_open_for_ms: 'Tạm dừng sau khi lỗi liên tiếp',
    epp_max_commands_per_session: 'Số lệnh tối đa mỗi phiên',
    epp_max_session_idle_ms: 'Đóng phiên nhàn rỗi sau',
    epp_max_session_lifetime_ms: 'Làm mới phiên sau',
    epp_classes: 'Nhóm phiên',
    class_sessions: 'Số phiên',
    class_requests_per_second: 'Lệnh mỗi giây',
    class_burst: 'Số lệnh dồn tối đa',
    rest_base_url: 'Địa chỉ dịch vụ',
    rest_auth_method: 'Cách Tino đăng nhập',
    rest_auth_settings: 'Thiết lập đăng nhập',
    rest_auth_settings_api_key_header: 'Tên trường chứa khoá',
    rest_auth_settings_token_url: 'Địa chỉ cấp mã truy cập',
    rest_auth_settings_scope: 'Phạm vi truy cập',
    rest_account_id: 'Mã tài khoản / đại lý tại nhà cung cấp',
    rest_connect_timeout_ms: 'Thời gian chờ kết nối',
    rest_request_timeout_ms: 'Thời gian chờ phản hồi',
  },
  provider: {
    name: {
      VNNIC_REGISTRAR_API: 'Registrar API của VNNIC',
      VNNIC_EKYC: 'eKYC của VNNIC',
      VNNIC_HSTM: 'Dịch vụ hồ sơ tên miền của VNNIC (HSTM)',
      VNNIC_GTLD_REPORTING: 'Báo cáo tên miền quốc tế (gTLD) gửi VNNIC',
      VNNIC_WHOIS: 'Dịch vụ WHOIS của VNNIC',
      VNPT_SMARTCA: 'VNPT SmartCA (ký số của nhà đăng ký)',
      CLOUDFLARE_TURNSTILE: 'Chống robot (Cloudflare Turnstile)',
    },
    tab: {
      VNNIC_REGISTRAR_API: 'Registrar API',
      VNNIC_EKYC: 'eKYC',
      VNNIC_HSTM: 'Hồ sơ (HSTM)',
      VNNIC_GTLD_REPORTING: 'Báo cáo gTLD',
      VNNIC_WHOIS: 'WHOIS',
      VNPT_SMARTCA: 'SmartCA',
      CLOUDFLARE_TURNSTILE: 'Chống robot',
    },
    description: {
      VNNIC_REGISTRAR_API: 'Tra cứu thông tin doanh nghiệp và hộ kinh doanh, mã khuyến mại tên miền miễn phí và khai báo hộ kinh doanh với VNNIC.',
      VNNIC_EKYC: 'Đọc giấy tờ tùy thân và đối chiếu khuôn mặt khi xác minh danh tính chủ thể.',
      VNNIC_HSTM: 'Tự động gửi hồ sơ tên miền .vn (bản khai và giấy tờ của chủ thể) sang VNNIC.',
      VNNIC_GTLD_REPORTING: 'Báo cáo các tên miền quốc tế Tino đang quản lý cho VNNIC: từng biến động khi phát sinh và danh sách tên miền duy trì định kỳ.',
      VNNIC_WHOIS: 'Kiểm tra tên miền .vn còn trống và thông tin đăng ký cho “Tra cứu tên miền” và API kiểm tra tên miền cho khách hàng, qua TLS hai chiều với chứng thư WHOIS riêng do VNNIC cấp (khác chứng thư EPP).',
      VNPT_SMARTCA: 'Nhà đăng ký ký số bản khai tên miền và các tệp nhân viên gửi ký bằng SmartCA của VNPT; xác nhận trên ứng dụng SmartCA.',
      CLOUDFLARE_TURNSTILE: 'Khách hàng xác minh mình không phải robot (bằng Cloudflare Turnstile) khi đăng nhập, đăng ký, quên mật khẩu, đặt mật khẩu mới và nhận lời mời vào tài khoản.',
    },
    offEffect: {
      VNNIC_REGISTRAR_API: 'Khi tắt, hệ thống không tra cứu thông tin doanh nghiệp; người duyệt kiểm tra tổ chức thủ công.',
      VNNIC_EKYC: 'Khi tắt, các yêu cầu xác minh danh tính sẽ chờ (giữ trạng thái đang xử lý) cho đến khi dịch vụ được bật lại.',
      VNNIC_HSTM: 'Khi tắt, hồ sơ được xuất ra để nộp thủ công cho VNNIC thay vì gửi tự động.',
      VNNIC_GTLD_REPORTING: 'Khi tắt, không có báo cáo gTLD nào được gửi tới VNNIC.',
      VNNIC_WHOIS: 'Khi tắt, tra cứu .vn dùng kết nối registry (EPP) của Tino hoặc trả lời “không rõ”.',
      VNPT_SMARTCA: 'Khi tắt, các lô ký chờ cho đến khi SmartCA được bật lại.',
      CLOUDFLARE_TURNSTILE: 'Khi tắt, khách không phải xác minh; việc tạm khoá địa chỉ nhập sai mật khẩu nhiều lần vẫn áp dụng.',
    },
    field: {
      base_url: 'Địa chỉ dịch vụ',
      timeout_ms: 'Thời gian chờ phản hồi',
      connect_timeout_ms: 'Thời gian chờ kết nối',
      ocr_path: 'Đường dẫn đọc giấy tờ',
      faceid_path: 'Đường dẫn đối chiếu khuôn mặt',
      max_attempts: 'Số lần thử mỗi yêu cầu',
      client_id: 'Mã ứng dụng (client ID)',
      maintain_hour_utc: 'Giờ gửi danh sách tên miền duy trì',
      chunk_size: 'Số tên miền mỗi lô',
      sp_id: 'Mã dịch vụ (SP ID)',
      user_id: 'Tài khoản SmartCA của người ký (CCCD / mã số thuế)',
      signature_text: 'Dòng chữ hiển thị trên chữ ký',
      site_key: 'Khoá trang (site key)',
      challenge_after_failures: 'Khi nào hỏi',
    },
    fieldHint: {
      client_id: 'Do VNNIC cấp; không phải thông tin bí mật.',
      sp_id: 'Do VNPT cấp cho nhà đăng ký.',
      signature_text: 'Ví dụ: NĐK Tino. Ngày ký được thêm ở dòng sau.',
      site_key: 'Lấy trong trang Turnstile của Cloudflare; không phải thông tin bí mật.',
    },
    secret: {
      client_id: 'Mã ứng dụng (client ID)',
      client_secret: 'Khoá bí mật của ứng dụng',
      api_key: 'Khoá truy cập',
      client_certificate: 'Chứng thư máy khách (PEM, kèm chuỗi)',
      client_private_key: 'Khoá riêng của chứng thư',
      client_key_passphrase: 'Mật khẩu khoá',
      ca_certificate: 'Chứng thư CA của VNNIC',
      sp_password: 'Mật khẩu dịch vụ (SP secret)',
      secret_key: 'Khoá bí mật (secret key)',
    },
    unit: { ms: 'ms', hour_utc: 'giờ (UTC)', records: 'tên miền', attempts: 'lần' },
    default: 'mặc định',
  },
  whoisImport: {
    title: 'Chứng thư WHOIS',
    description: 'VNNIC cấp một chứng thư máy khách riêng cho dịch vụ WHOIS. Nhập tệp PKCS#12 (.p12 / .pfx): chứng thư, khoá riêng (lưu mã hoá) và CA của VNNIC được đưa vào một phiên bản cấu hình mới; mật khẩu tệp không bao giờ được lưu.',
    open: 'Nhập PKCS#12…',
    dialogTitle: 'Nhập chứng thư WHOIS',
    file: 'Tệp PKCS#12 (.p12 / .pfx)',
    passphrase: 'Mật khẩu tệp',
    passphraseHint: 'Chỉ dùng một lần để mở tệp; không lưu, không ghi log, không hiển thị lại.',
    ca: 'Chứng thư CA của VNNIC (PEM, không bắt buộc)',
    caHint: 'Chỉ cần khi tệp không kèm CA của VNNIC; nếu có, hệ thống dùng CA trong tệp.',
    baseUrl: 'Địa chỉ dịch vụ',
    baseUrlHint: 'Để trống: địa chỉ VNNIC công bố cho loại máy chủ này (OT&E hoặc production).',
    submit: 'Nhập',
    done: 'Đã nhập chứng thư: {{subject}}, hiệu lực đến {{until}}.',
    pending: 'Đã tạo đề xuất: cần người thứ hai phê duyệt trước khi dùng.',
    tls: 'Kết nối dùng TLS 1.2 với duy nhất bộ mã AES256-SHA (máy chủ VNNIC không nhận trao đổi khoá hiện đại) và luôn xác thực chứng thư của VNNIC bằng CA này.',
  },
  applyMode: {
    allLive: 'Mọi thay đổi, kể cả bật/tắt, có hiệu lực trong khoảng {{seconds}} giây.',
    enabled: {
      LIVE: 'Việc bật/tắt có hiệu lực trong khoảng {{seconds}} giây.',
      RESTART: 'Việc bật/tắt có hiệu lực sau khi khởi động lại dịch vụ.',
    },
    settings: {
      LIVE: 'Các thay đổi khác có hiệu lực trong khoảng {{seconds}} giây.',
      RESTART: 'Các thay đổi khác có hiệu lực sau khi khởi động lại dịch vụ.',
    },
  },
  applied: {
    none: 'Chưa có dịch vụ nào báo đang dùng cấu hình này.',
    environment: 'Đang dùng cấu hình trên máy chủ (biến môi trường)',
    disabled: 'Đang tắt',
    version: 'Đang dùng phiên bản {{version}}',
    behind: 'Chưa chuyển sang phiên bản {{version}}',
    behindShort: 'Chưa chuyển sang phiên bản đang có hiệu lực',
    checked: 'cập nhật',
    formerSubject: 'tên cũ',
    moduleSubject: 'theo mô-đun',
    subjectHint: 'Báo cáo theo tên {{subject}}',
    error: {
      RESTART_REQUIRED: 'Cần khởi động lại để bật/tắt',
      SECRET_UNAVAILABLE: 'Không đọc được mật khẩu hoặc khoá',
      CONFIGURATION_INVALID: 'Cấu hình không dùng được; các lệnh gọi bị dừng',
      SETTINGS_UNAVAILABLE: 'Không đọc được cấu hình đã lưu; các lệnh gọi bị dừng',
    },
  },
  service: {
    admin_api: 'Máy chủ Control Center',
    api: 'API cho khách hàng',
    domain_worker: 'Xử lý tên miền',
    epp_poll_worker: 'Đọc thông báo từ nhà quản lý tên miền',
    reconciliation_worker: 'Đối soát với nhà quản lý tên miền',
    dropcatch_worker: 'Săn tên miền hết hạn',
    scheduler: 'Tác vụ theo lịch',
    identity_worker: 'Xác minh danh tính',
    vnnic_sync_worker: 'Gửi hồ sơ sang VNNIC',
    vnnic_reconciliation_worker: 'Đối soát hồ sơ với VNNIC',
    vnnic_report_worker: 'Gửi báo cáo gTLD cho VNNIC',
    client_auth: 'Đăng nhập khu vực khách hàng',
  },
  captcha: {
    howTitle: 'Cách hoạt động',
    forms: 'Áp dụng cho các trang đăng nhập, đăng ký, quên mật khẩu, đặt mật khẩu mới và nhận lời mời của khu vực khách hàng.',
    when: '“Luôn hỏi”: mọi lần gửi các trang trên. “Sau khi nhập sai”: chỉ hỏi khi một địa chỉ mạng hoặc một email đã nhập sai mật khẩu (hoặc mở liên kết sai) từ số lần đã chọn trở lên trong một giờ; trang đăng ký và quên mật khẩu luôn hỏi vì chúng gửi email.',
    failClosed: 'Nếu đã bật mà không kiểm tra được (sai khoá bí mật, Cloudflare không phản hồi), các trang trên tạm thời không nhận yêu cầu cho đến khi sửa xong. Sau mỗi lần đổi khoá, hãy bấm “Kiểm tra truy cập” rồi chọn kiểm tra đăng nhập.',
    lock: 'Việc tạm khoá một địa chỉ sau nhiều lần nhập sai mật khẩu vẫn được giữ như trước.',
    staff: 'Trang đăng nhập Control Center không dùng bước này: chỉ mở được từ các mạng được cho phép và luôn cần mã xác thực hai lớp.',
    always: 'Luôn hỏi',
    afterChoice: 'Sau khi nhập sai',
    afterFailures: 'Sau {{count}} lần nhập sai',
    alwaysHint: 'Hỏi ở mọi lần gửi trang.',
    afterHint: 'Trang đăng ký và quên mật khẩu vẫn luôn hỏi.',
    failures: 'Số lần nhập sai trong một giờ',
  },
  test: {
    tlsProblem: {
      UNKNOWN_ISSUER: 'Máy chủ dùng chứng thư do một CA riêng cấp: cần khai báo Root CA của nhà quản lý tên miền (tab Chứng thư số → Root CA).',
      NOT_VALID_FOR_NAME: 'Chứng thư máy chủ không mang tên máy chủ đang kết nối: kiểm tra địa chỉ, hoặc tên máy chủ TLS trong thiết lập kết nối.',
      EXPIRED: 'Chứng thư của máy chủ đã hết hạn.',
      NOT_YET_VALID: 'Chứng thư của máy chủ chưa đến ngày hiệu lực (hoặc đồng hồ máy chủ Control Center bị lệch).',
      REVOKED: 'Chứng thư của máy chủ đã bị thu hồi.',
      OTHER: 'Chứng thư của máy chủ không hợp lệ.',
    },
    serverChain: {
      title: 'Chứng thư máy chủ đã trình ra',
      leaf: 'Máy chủ',
      noCa: 'Máy chủ không gửi kèm CA. Hãy lấy tệp Root CA từ nhà quản lý tên miền rồi tải lên ở tab Chứng thư số → Root CA.',
      compare: 'Trước khi tin cậy, đối chiếu dấu vân tay SHA-256 với dấu vân tay nhà quản lý tên miền công bố (hoặc với tệp Root CA họ gửi).',
      trust: 'Dùng CA này làm Root CA',
    },
    never: 'Chưa kiểm tra lần nào',
    none: 'Chưa có lần kiểm tra nào.',
    show: 'Chi tiết',
    hide: 'Ẩn',
    by: 'bởi',
    outcome: { OK: 'Đạt', FAILED: 'Không đạt' },
    kind: {
      EPP_HANDSHAKE: 'Kết nối và lời chào',
      EPP_LOGIN: 'Kiểm tra đăng nhập bằng tài khoản đã lưu',
      HTTPS_REACHABILITY: 'Kiểm tra khả năng truy cập',
      API_LOGIN: 'Kiểm tra đăng nhập',
    },
    step: {
      DNS: 'Tra cứu địa chỉ',
      TCP: 'Kết nối',
      TLS: 'Mã hoá',
      GREETING: 'Lời chào của nhà quản lý',
      LOGIN: 'Đăng nhập',
      LOGOUT: 'Đăng xuất',
      HTTP: 'Phản hồi của dịch vụ',
      TOKEN: 'Lấy token',
      API_CALL: 'Gọi API đã xác thực',
    },
    stepStatus: { OK: 'Đạt', FAILED: 'Lỗi', SKIPPED: 'Bỏ qua' },
    error: {
      DNS_NOT_FOUND: 'Không tìm thấy địa chỉ.',
      ADDRESS_NOT_ALLOWED: 'Không được phép kiểm tra tới địa chỉ này.',
      CONNECT_REFUSED: 'Máy chủ từ chối kết nối.',
      CONNECT_TIMEOUT: 'Máy chủ không phản hồi kịp thời.',
      TLS_HANDSHAKE_FAILED: 'Không thiết lập được kết nối mã hoá.',
      TLS_CERTIFICATE_INVALID: 'Chứng thư của máy chủ không được tin cậy.',
      CLIENT_CERTIFICATE_REJECTED: 'Máy chủ từ chối chứng thư số của Tino.',
      GREETING_TIMEOUT: 'Nhà quản lý không gửi lời chào kịp thời.',
      GREETING_INVALID: 'Không đọc được lời chào.',
      LOGIN_REJECTED: 'Nhà quản lý từ chối đăng nhập.',
      LOGIN_TIMEOUT: 'Nhà quản lý không phản hồi đăng nhập kịp thời.',
      HTTP_TIMEOUT: 'Dịch vụ không phản hồi kịp thời.',
      HTTP_INVALID_RESPONSE: 'Có máy chủ trả lời ở địa chỉ này nhưng không phải dịch vụ web.',
      SECRET_UNAVAILABLE: 'Không đọc được mật khẩu hoặc khoá đã lưu.',
      CONFIGURATION_INVALID: 'Cấu hình hiện tại không dùng được.',
      WRONG_CREDENTIALS: 'Sai tên đăng nhập hoặc mật khẩu API.',
      IP_NOT_ALLOWED: 'Nhà cung cấp chưa cho phép địa chỉ IP của máy chủ này: cần thêm vào danh sách IP được phép của tài khoản.',
      CREDENTIALS_REJECTED: 'Nhà cung cấp từ chối đăng nhập nhưng không nói lý do: kiểm tra tên đăng nhập, mật khẩu API và danh sách IP được phép của tài khoản.',
      API_REJECTED: 'Đăng nhập được nhưng nhà cung cấp từ chối lệnh đọc.',
      API_TIMEOUT: 'Nhà cung cấp không phản hồi kịp thời.',
      API_UNREACHABLE: 'Không kết nối được tới nhà cung cấp (tra cứu địa chỉ, kết nối hoặc mã hoá không thành công).',
      API_UNEXPECTED_RESPONSE: 'Nhà cung cấp trả lời không như mong đợi.',
    },
    interpretation: {
      REACHABLE: 'Dịch vụ đã phản hồi.',
      REACHABLE_AUTH_REQUIRED: 'Dịch vụ đã phản hồi và yêu cầu đăng nhập (đúng như dự kiến: lần kiểm tra này không gửi thông tin đăng nhập).',
      REACHABLE_REDIRECT: 'Dịch vụ phản hồi bằng chuyển hướng (không đi theo).',
      REACHABLE_SERVER_ERROR: 'Dịch vụ phản hồi lỗi máy chủ.',
    },
    viaProxy: 'Được máy chủ proxy đầu ra tra cứu',
    serverCertificate: 'Chứng thư máy chủ {{subject}}, còn {{days}} ngày hiệu lực',
    clientCertificate: 'Chứng thư số phiên bản {{version}}',
    serverId: 'Máy chủ: {{id}}',
    services: 'Cung cấp {{objects}} loại đối tượng, {{extensions}} phần mở rộng',
    missingExtensions: 'Máy chủ không cung cấp: {{list}}',
    resultCode: 'Nhà quản lý trả lời {{code}}: {{message}}',
    httpStatus: 'Mã trạng thái {{status}}',
    endpoint: 'Lệnh: {{endpoint}}',
    providerCode: 'Mã trả lời: {{code}}',
    balances: 'Số dư: {{list}}',
    itemCount: 'Nhận được {{count}} mục',
    egress: 'Địa chỉ IP đi ra của máy chủ này: {{list}}',
    loginNote: 'Lần kiểm tra này dùng thông tin đăng nhập đã lưu; mật khẩu và token không bao giờ được hiển thị hay ghi vào lịch sử.',
    testedVersion: 'Cấu hình phiên bản {{version}}',
    credentialVersion: 'Thông tin đăng nhập phiên bản {{version}}',
    certificateVersion: 'Chứng thư số phiên bản {{version}}',
    probe: 'Nơi chạy kiểm tra: {{service}}. Các dịch vụ dùng kết nối này có thể đi ra từ địa chỉ mạng khác, trong khi VNNIC và hầu hết nhà quản lý tên miền chỉ chấp nhận các địa chỉ đã đăng ký.',
    bannerNote: 'Việc kiểm tra không thay đổi cấu hình nào; kết quả được ghi vào lịch sử.',
    reachabilityOnly: 'Lần kiểm tra này không gửi thông tin đăng nhập, dữ liệu cá nhân hay yêu cầu nghiệp vụ nào; nó không chứng minh thông tin đăng nhập đã lưu là đúng.',
    dialogTitle: 'Kiểm tra kết nối tới {{name}}',
    dialogDescription: 'Việc kiểm tra chạy từ máy chủ của Control Center và được ghi vào lịch sử thay đổi.',
    providerDialogTitle: 'Kiểm tra kết nối tới {{name}}',
    modeLabel: 'Nội dung kiểm tra',
    mode: {
      HANDSHAKE: 'Kết nối, mã hoá và lời chào',
      LOGIN: 'Kiểm tra đăng nhập bằng tài khoản đã lưu',
      REACHABILITY: 'Kiểm tra khả năng truy cập',
      API_LOGIN: 'Kiểm tra đăng nhập',
    },
    modeHint: {
      API_LOGIN: 'Đăng nhập bằng thông tin đăng nhập đã lưu rồi thực hiện một lệnh chỉ đọc ({{call}}). Không thay đổi gì ở nhà cung cấp và không phát sinh phí.',
      HANDSHAKE: 'Kết nối tới nhà quản lý tên miền, thiết lập mã hoá bằng chứng thư số và đọc lời chào của máy chủ. Không đăng nhập.',
      LOGIN:
        'Đăng nhập thêm bằng tài khoản đã lưu rồi đăng xuất. Thao tác này mở một phiên thật với nhà quản lý tên miền và được tính vào giới hạn phiên của họ. Mỗi {{seconds}} giây chỉ được một lần và tối đa {{perHour}} lần mỗi giờ.',
      REACHABILITY: 'Tra cứu địa chỉ, thiết lập mã hoá và yêu cầu dịch vụ trả lời một lần, không kèm thông tin đăng nhập hay dữ liệu. Không kiểm tra tên đăng nhập, mật khẩu hay khoá.',
    },
    versionLabel: 'Cấu hình dùng để kiểm tra',
    activeVersion: 'Cấu hình đang có hiệu lực (phiên bản {{version}})',
    pendingVersion: 'Cấu hình đề xuất (phiên bản {{version}}, chờ phê duyệt)',
    credentialLabel: 'Thông tin đăng nhập dùng để kiểm tra',
    credentialActive: 'Thông tin đang dùng',
    credentialPending: 'Thông tin đề xuất (phiên bản {{version}})',
    limits: 'Mỗi kết nối chỉ được kiểm tra một lần trong {{seconds}} giây.',
    address: 'Địa chỉ',
    noAddress: 'Chưa có địa chỉ.',
    run: 'Chạy kiểm tra',
    runAgain: 'Kiểm tra lại',
    running: 'Đang kiểm tra…',
    loginOnlyInForce: 'Chỉ dùng cho phiên bản đang áp dụng: địa chỉ đang đề xuất được kiểm tra mà không đăng nhập.',
    apiLoginOnlyInForce: 'Chỉ dùng cho địa chỉ đang áp dụng: thông tin đăng nhập đã lưu không được gửi tới một địa chỉ đang chờ phê duyệt.',
    loginCall: {
      webnic: 'xem số dư tài khoản',
      VNNIC_REGISTRAR_API: 'xem số dư ký quỹ',
      VNNIC_HSTM: 'đọc danh mục loại hồ sơ',
      other: 'lệnh đọc',
    },
  },
  changes: {
    selfApprove: 'Tự duyệt',
    selfApproveTitle: 'Tự duyệt thay đổi của bạn',
    selfApproveDescription: 'Dành cho cấp quản trị khi không có người thứ hai. Được ghi vào lịch sử là tự duyệt.',
    selfApproveNoticeTitle: 'Bạn đang tự duyệt thay đổi của chính mình',
    selfApproveNotice: 'Không có người thứ hai kiểm tra thay đổi này. Hãy đọc kỹ từng giá trị ở trên; quyết định được ghi vào lịch sử kèm tên bạn và đánh dấu “tự duyệt”.',
    totp: 'Mã xác thực hiện tại',
    totpHint: 'Mã 6 số trong ứng dụng xác thực (không dùng lại mã đã dùng để đăng nhập).',
    mineSelfApprove: 'Bạn là người đề xuất thay đổi này. Với cấp quản trị, bạn có thể tự duyệt (nhập lại mã xác thực); nếu có người thứ hai, nên để họ duyệt.',
    selfApproved: 'Người đề xuất đã tự duyệt thay đổi này (cấp quản trị).',
    title_one: 'Thay đổi chờ phê duyệt ({{count}})',
    title_other: 'Thay đổi chờ phê duyệt ({{count}})',
    description: 'Thay đổi trên máy chủ chính thức được lưu thành đề xuất. Người thứ hai phê duyệt, sau đó một người có cùng quyền áp dụng.',
    none: 'Không có thay đổi nào chờ phê duyệt.',
    noneHere: 'Trang này không có thay đổi nào đang chờ.',
    loading: 'Đang tải các thay đổi chờ phê duyệt…',
    loadFailed: 'Không tải được các thay đổi chờ phê duyệt',
    elsewhere_one: 'Có {{count}} thay đổi đang chờ ở trang khác:',
    elsewhere_other: 'Có {{count}} thay đổi đang chờ ở các trang khác:',
    page: { registries: 'Kết nối registry', tlds: 'Kênh đăng ký TLD', vnnic: 'Tích hợp VNNIC', modules: 'Module' },
    kind: {
      CONNECTION_UPDATE: 'Thông tin kết nối',
      ENVIRONMENT_VERSION: 'Địa chỉ và thiết lập kết nối',
      CREDENTIAL_VERSION: 'Thông tin đăng nhập',
      CERTIFICATE_VERSION: 'Chứng thư số',
      TLD_CHANNEL: 'Kênh đăng ký của TLD',
      TLD_CHANNEL_BATCH: 'Kênh đăng ký của nhiều TLD',
      PROVIDER_SETTING_VERSION: 'Cấu hình dịch vụ VNNIC',
      SPONSORING_REGISTRAR: 'Nhà đăng ký quản lý (báo cáo gTLD)',
      MODULE_INSTANCE_VERSION: 'Cài đặt module',
    },
    version: 'phiên bản {{version}}',
    tldCount_one: '{{count}} TLD',
    tldCount_other: '{{count}} TLD',
    requestedBy: 'Đề xuất bởi',
    decidedBy: 'Quyết định bởi',
    expires: 'hết hạn {{when}}',
    reason: 'Lý do',
    stale: 'Cấu hình đã thay đổi sau đề xuất này nên không thể áp dụng nữa. Hãy huỷ và đề xuất lại.',
    mine: 'Bạn là người đề xuất thay đổi này. Cần một người khác có quyền {{permission}} phê duyệt.',
    waiting: 'Đang chờ người có quyền {{permission}}.',
    approvedWaiting: 'Đã phê duyệt. Người có quyền {{permission}} có thể áp dụng.',
    noFieldChanges: 'Không có trường nào thay đổi.',
    hiddenValue: 'đã thay đổi (bị ẩn: cần quyền quản lý thông tin đăng nhập)',
    tldMore_one: 'và {{count}} TLD khác',
    tldMore_other: 'và {{count}} TLD khác',
    secretReplaced: 'đã thay ({{source}})',
    secretRemoved: 'đã gỡ bỏ',
    decide: 'Phê duyệt hoặc từ chối',
    apply: 'Áp dụng thay đổi',
    cancel: 'Huỷ thay đổi',
    decideTitle: 'Phê duyệt hoặc từ chối thay đổi',
    decideDescription: 'Bạn là người thứ hai. Hãy đối chiếu các giá trị với yêu cầu trước khi quyết định.',
    decision: 'Quyết định',
    approve: 'Phê duyệt',
    reject: 'Từ chối',
    approveAndApply: 'Phê duyệt và áp dụng',
    applyNow: 'Áp dụng ngay sau khi phê duyệt (hai bước riêng, đều được ghi nhận)',
    confirmApprove: 'Tôi đã kiểm tra thay đổi này và phê duyệt với tư cách của mình.',
    confirmReject: 'Tôi từ chối thay đổi này; đề xuất sẽ được đóng.',
    applyTitle: 'Áp dụng thay đổi đã phê duyệt',
    applyDescription: 'Hệ thống áp dụng đúng đề xuất đã được phê duyệt; không thể chỉnh sửa ở bước này.',
    confirmApply: 'Áp dụng thay đổi đã phê duyệt ngay bây giờ.',
    cancelTitle: 'Huỷ thay đổi này',
    cancelDescription: 'Đề xuất sẽ được đóng và không có gì thay đổi.',
    cancelConfirm: 'Huỷ thay đổi',
    finished: { approved: 'Đã phê duyệt', applied: 'Đã áp dụng', rejected: 'Đã từ chối' },
    bannerDecide: 'Việc phê duyệt tự nó chưa thay đổi gì; thay đổi chỉ có hiệu lực khi được áp dụng.',
    bannerApply: 'Áp dụng sẽ đưa thay đổi đã phê duyệt vào hiệu lực; các dịch vụ đang chạy nhận thay đổi trong khoảng {{seconds}} giây.',
    finishedApprovedHint: 'Giờ có thể áp dụng thay đổi từ mục thay đổi chờ phê duyệt.',
  },
  connections: {
    title: 'Kết nối registry',
    subtitle: 'Cách Tino kết nối tới từng nhà quản lý tên miền: trực tiếp (EPP hoặc dịch vụ web của nhà quản lý) hoặc qua nhà đăng ký trung gian.',
    add: 'Thêm kết nối',
    explainTitle: 'Kết nối và kênh đăng ký',
    explain:
      'Kết nối là con đường Tino gửi đăng ký, gia hạn và chuyển nhượng: trực tiếp tới nhà quản lý tên miền, hoặc qua một nhà đăng ký trung gian đăng ký thay cho Tino. Mỗi TLD dùng một kết nối; lựa chọn đó là kênh đăng ký của TLD.',
    toTlds: 'Chọn kênh đăng ký cho từng TLD →',
    filter: { kind: 'Loại', protocol: 'Cách kết nối', status: 'Trạng thái', search: 'Tìm kiếm', searchPlaceholder: 'Tên hoặc mã' },
    loading: 'Đang tải danh sách kết nối…',
    loadFailed: 'Không tải được danh sách kết nối',
    empty: 'Không có kết nối phù hợp',
    emptyHint: 'Hãy đổi bộ lọc hoặc thêm kết nối mới.',
    envNotConfigured: 'Chưa thiết lập',
    ready: 'Sẵn sàng',
    notReady: 'Chưa sẵn sàng',
    changeWaiting: 'Có thay đổi đang chờ',
    noEndpoint: 'Chưa có địa chỉ',
    credential: 'Thông tin đăng nhập v{{version}} · {{source}}',
    noCredential: 'Chưa có thông tin đăng nhập',
    certificateDays_one: 'Chứng thư số: còn {{count}} ngày',
    certificateDays_other: 'Chứng thư số: còn {{count}} ngày',
    noCertificate: 'Chưa có chứng thư số',
    version0: 'Thiết lập ngoài Control Center',
    version: 'Cấu hình v{{version}}',
    iana: 'IANA {{id}} · {{name}}',
    tlds_one: '{{count}} TLD',
    tlds_other: '{{count}} TLD',
    domains_one: 'Đang quản lý {{formatted}} tên miền',
    domains_other: 'Đang quản lý {{formatted}} tên miền',
    openChanges_one: '{{count}} thay đổi đang chờ',
    openChanges_other: '{{count}} thay đổi đang chờ',
    open: 'Mở',
  },
  create: {
    title: 'Thêm kết nối',
    description: 'Kết nối mới chưa được dùng cho đến khi được bật và có TLD chọn nó làm kênh đăng ký.',
    kindLabel: 'Kết nối tới ai?',
    protocolLabel: 'Tino kết nối bằng cách nào?',
    upstreamRest: 'Nhà đăng ký trung gian được kết nối qua dịch vụ web của họ.',
    channelPreview: 'Các TLD dùng kết nối này sẽ có kênh:',
    code: 'Mã',
    codeHint: 'Mã ngắn, cố định: 2–32 chữ thường, chữ số hoặc dấu gạch ngang. Không thể đổi sau này.',
    codeInvalid: 'Dùng 2–32 chữ thường, chữ số hoặc dấu gạch ngang, bắt đầu bằng chữ hoặc số.',
    name: 'Tên hiển thị',
    adapter: 'Phần tích hợp',
    adapterHint: 'Cổng EPP của VNNIC bổ sung các quy định riêng của VNNIC trên nền EPP tiêu chuẩn.',
    noRestAdapters: 'Phiên bản nền tảng này chưa có phần tích hợp dịch vụ web nào.',
    spec: 'Tài liệu kỹ thuật của nhà cung cấp (tên / phiên bản)',
    specHint: 'Chỉ để tham khảo, ví dụ tên và phiên bản tài liệu nhà cung cấp gửi cho Tino.',
    nextSteps: 'Sau khi thêm, form nhập địa chỉ mở ra ngay; tiếp theo là thông tin đăng nhập (và chứng thư số với EPP).',
    reasonLabel: 'Lý do',
    confirmLabel: 'ô xác nhận',
    missing: 'Còn thiếu: {{fields}}',
    confirm: 'Tôi đã kiểm tra loại, mã và thông tin ở trên; mã không thể đổi sau này.',
    submit: 'Thêm kết nối',
    created: 'Đã thêm kết nối. Kết nối chưa được dùng cho đến khi được bật và có TLD chọn nó.',
    openNew: 'Nhập địa chỉ',
    presetLabel: 'Bắt đầu từ nhà cung cấp đã biết',
    presetHint: 'Điền sẵn biểu mẫu bên dưới; hãy kiểm tra mọi giá trị trước khi thêm kết nối.',
    preset: {
      VNNIC_EPP: { title: 'Cổng EPP của VNNIC', body: 'Nhà quản lý tên miền .vn. Kết nối trực tiếp bằng chứng thư máy khách.' },
      WEBNIC: { title: 'WebNIC', body: 'Nhà đăng ký đối tác cho các TLD Tino không đăng ký trực tiếp được. Đăng nhập bằng tên người dùng và khoá bí mật WebNIC.' },
    },
  },
  upstream: {
    title: 'Nhà đăng ký trung gian',
    hint: 'Nhà đăng ký này quản lý các tên miền Tino đăng ký qua họ; mã IANA và tên của họ được gửi cho VNNIC làm nhà đăng ký quản lý trong báo cáo gTLD.',
    legalName: 'Tên pháp lý',
    tradeName: 'Tên nhà đăng ký (theo công nhận)',
    ianaId: 'Mã nhà đăng ký IANA',
    ianaInvalid: 'Là số nguyên dương.',
  },
  connection: {
    loading: 'Đang tải kết nối…',
    loadFailed: 'Không tải được kết nối',
    notFound: 'Không có kết nối với mã này',
    envLoadFailed: 'Không tải được cấu hình kết nối',
    sections: 'Các mục của kết nối',
    tab: {
      overview: 'Tổng quan',
      environments: 'Địa chỉ',
      credentials: 'Thông tin đăng nhập',
      certificates: 'Chứng thư số',
      settings: 'Thiết lập kết nối',
      tests: 'Kiểm thử',
      history: 'Lịch sử',
    },
  },
  role: {
    title: 'Vai trò nhà đăng ký',
    hint: 'Ai thực hiện nghĩa vụ của nhà đăng ký (RAA) với tên miền giữ qua kết nối này. Mặc định: WebNIC là nhà đăng ký cấp trên, các kết nối khác là nhà đăng ký chính thức.',
    current: 'Vai trò',
    duties: 'Hệ quả',
    change: 'Đổi vai trò',
    changeTitle: 'Đổi vai trò thành {{role}}',
    changeTo: 'Đổi thành {{role}}',
    changed: 'Đã đổi vai trò.',
    value: { REGISTRAR_OF_RECORD: 'Nhà đăng ký chính thức (Tino)', UPSTREAM_REGISTRAR: 'Nhà đăng ký cấp trên' },
    effect: {
      REGISTRAR_OF_RECORD: 'Tino gửi e-mail xác minh WHOIS (đăng ký, chuyển về, đổi chủ thể) và tạm ngưng nếu không xác minh; dịch vụ ẩn WHOIS dùng hồ sơ công bố của Tino.',
      UPSTREAM_REGISTRAR: 'Nhà đăng ký cấp trên xác minh chủ thể và tạm ngưng; Tino không gửi e-mail xác minh riêng, đọc lại trạng thái vào trang tên miền, có "Gửi lại email xác minh"; dịch vụ ẩn WHOIS bật / tắt tại nhà đăng ký cấp trên.',
    },
  },
  overview: {
    identity: 'Kết nối',
    edit: 'Sửa thông tin',
    name: 'Tên',
    code: 'Mã',
    kind: 'Loại',
    channel: 'Kênh của các TLD dùng kết nối này',
    protocol: 'Cách kết nối',
    adapter: 'Phần tích hợp',
    status: 'Trạng thái',
    spec: 'Tài liệu của nhà cung cấp',
    noSpec: 'Chưa ghi nhận',
    inProductionUse: 'Đang dùng trên máy chủ chính thức',
    inProductionUseHint: 'Vì đang được dùng chính thức, việc đổi trạng thái, phần tích hợp hoặc thông tin nhà đăng ký trung gian cần người thứ hai phê duyệt.',
    domainsHeld: 'Tên miền đang quản lý',
    created: 'Ngày tạo',
    updated: 'Thay đổi gần nhất',
    sponsorTitle: 'Nhà đăng ký quản lý trong báo cáo gTLD gửi VNNIC',
    sponsorDescription: 'Báo cáo tên miền quốc tế gửi VNNIC ghi rõ nhà đăng ký được công nhận đang quản lý từng tên miền.',
    sponsorSource: 'Nguồn thông tin',
    sponsorUpstream: 'Với nhà đăng ký trung gian, đây là thông tin của chính họ; sửa bằng nút “Sửa thông tin”.',
    sponsorMapping: 'Với kết nối trực tiếp tới nhà quản lý tên miền, đây là thông tin công nhận của Tino, được đặt ở trang VNNIC.',
    toSponsors: 'Nhà đăng ký quản lý →',
    environments: 'Cấu hình kết nối',
    environmentsHint: 'Những gì kết nối cần trước khi TLD có thể dùng nó.',
    envMissing: 'Chưa được thiết lập.',
    openEnv: 'Mở thiết lập',
    configureEnv: 'Thiết lập',
    tlds: 'TLD dùng kết nối này',
    tldsHint: 'Đăng ký mới và chuyển đến của các TLD này đi qua kết nối này. “mặc định” nghĩa là chưa chọn kênh và TLD dùng kết nối mặc định.',
    toTlds: 'Kênh đăng ký TLD',
    noTlds: 'Không có TLD nào.',
    capabilities: 'Quy định của nhà quản lý đang áp dụng',
    capabilitiesHint: 'Do nhóm nền tảng ghi nhận; chỉ xem tại đây.',
    capabilitiesVersion: 'Phiên bản {{version}}, áp dụng từ {{from}}',
    noCapabilities: 'Chưa được ghi nhận.',
  },
  exercise: {
    title: 'Chạy thử nghiệp vụ OT&E',
    description:
      'Chạy lần lượt mọi thao tác tên miền trên hệ thống thử nghiệm (OT&E) của nhà quản lý, từ máy chủ OT&E: đăng ký một tên miền thử với thông tin liên hệ giả, rồi thay đổi, gia hạn…, và cho biết nhà quản lý trả lời gì ở từng bước. Không gửi gì tới hệ thống chính thức.',
    run: 'Chạy thử nghiệp vụ OT&E',
    runAgain: 'Chạy lại',
    running: 'Đang chạy…',
    starting: 'Đang bắt đầu…',
    oteOnly: 'Việc chạy thử này chỉ dùng trên máy chủ thử nghiệm (OT&E); máy chủ này là máy chủ chính thức.',
    dialogTitle: 'Chạy thử nghiệp vụ OT&E trên {{name}}',
    dialogDescription: 'Các lệnh thật được gửi tới hệ thống thử nghiệm (OT&E) của nhà quản lý. Lần chạy được ghi lại kèm tên bạn.',
    banner: 'Một tên miền thử và các liên hệ thử mới được tạo trên OT&E. Hãy chọn các bước; bước nào cần bước khác thì bước đó được chọn theo.',
    stepsLabel: 'Các bước',
    stepShort: { CHECK: 'kiểm tra tên', CONTACTS: 'tạo liên hệ', CREATE: 'đăng ký' },
    needs: 'cần bước {{list}}',
    deleteHint: 'Mặc định không chạy: nhà quản lý có thể từ chối việc xoá.',
    limits: 'Mỗi lần chỉ một lượt chạy; bắt đầu lượt mới cách nhau ít nhất {{seconds}} giây và tối đa {{perHour}} lượt mỗi giờ.',
    latest: 'Lượt chạy gần nhất',
    history: 'Các lượt trước',
    none: 'Chưa chạy lượt nào.',
    show: 'Chi tiết',
    hide: 'Ẩn',
    by: 'bởi',
    domain: 'Tên miền thử',
    progress: '{{done}}/{{total}} bước',
    status: { RUNNING: 'Đang chạy', PASSED: 'Mọi bước đều đạt', FAILED: 'Có bước không đạt', ABANDONED: 'Bị gián đoạn' },
    abandonedHint: 'Máy chủ chạy lượt này đã khởi động lại trước khi xong. Hãy chạy lượt mới.',
    probe: 'Nơi chạy: {{service}} (nhà quản lý chỉ chấp nhận các địa chỉ máy chủ đã đăng ký).',
    step: {
      CHECK: 'Kiểm tra tên miền thử còn trống',
      CONTACTS: 'Tạo các liên hệ thử (chủ thể, quản lý, kỹ thuật, thanh toán)',
      CREATE: 'Đăng ký tên miền 1 năm với 2 máy chủ tên',
      INFO: 'Đọc lại thông tin tên miền từ nhà quản lý',
      NAMESERVERS: 'Đổi máy chủ tên (thêm một, bỏ một)',
      LOCK: 'Khoá rồi mở khoá chuyển đi',
      AUTH_INFO: 'Đổi mã chuyển tên miền',
      DNSSEC: 'Thêm rồi gỡ một khoá DNSSEC',
      RENEW: 'Gia hạn 1 năm và kiểm tra ngày hết hạn mới',
      REGISTRANT_CHANGE: 'Đổi chủ thể sang một liên hệ mới',
      TRANSFER: 'Yêu cầu chuyển với mã sai (phải bị từ chối), rồi hỏi trạng thái chuyển',
      POLL: 'Đọc và xác nhận một thông báo của nhà quản lý',
      DELETE: 'Xoá tên miền thử',
    },
    stepStatus: { PASSED: 'Đạt', FAILED: 'Không đạt', UNKNOWN: 'Chưa rõ', SKIPPED: 'Bỏ qua', PENDING: 'Chờ', ACTIVE: 'Đang chạy' },
    note: {
      BLOCKED: 'Không chạy vì bước “{{step}}” không đạt.',
      NOT_SUPPORTED: 'Nhà quản lý không cung cấp thao tác này.',
      NAME_NOT_AVAILABLE: 'Tên miền thử không còn trống.',
      REJECTED: 'Nhà quản lý từ chối (xem câu trả lời bên dưới).',
      OUTCOME_UNKNOWN: 'Không có câu trả lời rõ ràng: nhà quản lý có thể đã hoặc chưa thực hiện. Không gửi lại.',
      NOT_SENT: 'Chưa có gì tới được nhà quản lý (kết nối, đăng nhập, hoặc bị chặn trước khi gửi).',
      UNEXPECTED_RESULT: 'Nhà quản lý có trả lời nhưng không như mong đợi.',
      MISMATCH: 'Nhà quản lý chấp nhận, nhưng đọc lại tên miền không thấy thay đổi.',
      NO_MESSAGE: 'Không có thông báo nào đang chờ nên chưa thử xác nhận được.',
      STEP_TIMEOUT: 'Bước này quá lâu; lượt chạy thôi chờ bước này.',
    },
    commands: 'Các lệnh đã gửi',
    commandLine: '{{command}} · {{outcome}}',
    commandOutcome: { SUCCESS: 'chấp nhận', REJECTED: 'từ chối', UNKNOWN: 'chưa rõ', NOT_SENT: 'chưa gửi' },
    resultCode: 'mã trả lời {{code}}',
    svTrid: 'mã giao dịch của nhà quản lý',
    clTrid: 'mã giao dịch của Tino',
    fact: {
      domain: 'Tên miền',
      available: 'Còn trống',
      reason: 'Lý do',
      registrant: 'Chủ thể',
      admin: 'Liên hệ quản lý',
      tech: 'Liên hệ kỹ thuật',
      billing: 'Liên hệ thanh toán',
      period_years: 'Số năm',
      nameservers: 'Máy chủ tên',
      created_at: 'Ngày đăng ký',
      expires_at: 'Ngày hết hạn',
      pending_review: 'Chờ nhà quản lý duyệt',
      statuses: 'Trạng thái',
      contacts: 'Liên hệ',
      sponsored_by_us: 'Đang do Tino quản lý',
      expected: 'Mong đợi',
      found: 'Tìm thấy',
      added: 'Đã thêm',
      removed: 'Đã bỏ',
      nameservers_after: 'Máy chủ tên sau khi đổi',
      lock: 'Khoá',
      locked_before: 'Khoá lúc đầu',
      locked_after_1: 'Khoá sau lần đổi thứ nhất',
      locked_after_2: 'Khoá sau lần đổi thứ hai',
      changed: 'Đã đổi',
      key_tag: 'Key tag',
      algorithm: 'Thuật toán',
      digest_type: 'Kiểu digest',
      expires_before: 'Hết hạn trước khi gia hạn',
      expected_after: 'Hết hạn mong đợi',
      expires_after: 'Hết hạn sau khi gia hạn',
      new_registrant: 'Chủ thể mới',
      registrant_after: 'Chủ thể sau khi đổi',
      expected_request_code: 'Mã trả lời mong đợi cho mã sai',
      request_code: 'Mã trả lời cho mã sai',
      query_status: 'Trạng thái chuyển',
      query_code: 'Mã trả lời khi hỏi trạng thái',
      messages: 'Số thông báo đang chờ',
      message_id: 'Thông báo',
      remaining: 'Số thông báo còn lại',
      queued_at: 'Thời điểm xếp hàng',
      object: 'Về',
      statuses_after: 'Trạng thái sau khi xoá',
      found_after: 'Vẫn còn tìm thấy',
      ds_found_after_add: 'Đọc lại được bản ghi DS sau khi thêm',
    },
  },
  envTab: {
    addressTitle: 'Địa chỉ',
    edit: 'Đổi địa chỉ',
    configure: 'Thiết lập',
    test: 'Kiểm tra kết nối',
    blocked: 'Đã có một thay đổi đang chờ phê duyệt. Hãy phê duyệt, áp dụng hoặc huỷ nó trước.',
    notConfigured: 'Chưa thiết lập trên {{env}}',
    notConfiguredHint: 'Hãy nhập địa chỉ để bắt đầu; chưa có gì được dùng cho đến khi bạn bật kết nối.',
    notConfiguredVnnic: 'Khi thiết lập, hệ thống sẽ gợi ý các địa chỉ VNNIC công bố (OT&E và production).',
    versionInForce: 'Phiên bản {{version}} đang có hiệu lực',
    sameAsHost: 'Trùng với địa chỉ máy chủ',
    extraCa: 'Có cấu hình tổ chức cấp chứng thư bổ sung',
    systemCa: 'Các tổ chức cấp chứng thư tin cậy mặc định',
    pendingTitle: 'Phiên bản {{version}} đang chờ phê duyệt',
    pendingBody: 'Các giá trị đề xuất được liệt kê bên dưới. Chúng chỉ có hiệu lực sau khi được phê duyệt và áp dụng.',
    readiness: 'Đã sẵn sàng chưa?',
    applied: 'Các dịch vụ đang dùng kết nối',
    appliedHint: 'Phiên bản cấu hình mà từng dịch vụ đang chạy đã nạp.',
    tests: 'Các lần kiểm tra gần đây',
    testsHint: 'Mỗi lần kiểm tra được ghi nhận kèm người thực hiện.',
    history: 'Lịch sử phiên bản',
  },
  envDialog: {
    titleEndpoint: 'Địa chỉ của {{name}}',
    titleSettings: 'Thiết lập kết nối của {{name}}',
    description: 'Toàn bộ cấu hình được lưu thành phiên bản mới; phiên bản cũ vẫn nằm trong lịch sử.',
    firstTime: 'Kết nối được thiết lập lần đầu.',
    enabled: 'Bật kết nối',
    enabledHint: 'Khi tắt, nền tảng không dùng kết nối này.',
    presetInUse: 'đang dùng',
    hostHint: 'Chỉ nhập tên máy chủ hoặc địa chỉ IP, không kèm “https://”.',
    tlsHint: 'Rất nên bật; bắt buộc trên máy chủ chính thức.',
    tlsRequired: 'Luôn bật trên máy chủ chính thức.',
    advancedTls: 'Thiết lập mã hoá nâng cao',
    serverNameHint: 'Chỉ nhập nếu chứng thư của máy chủ mang tên khác với địa chỉ.',
    caHint: 'Chỉ dùng nếu nhà quản lý có tổ chức cấp chứng thư riêng; dán các chứng thư công khai.',
    baseUrlHint: 'Địa chỉ nhà cung cấp cấp cho Tino, bắt đầu bằng https://.',
    httpsRequired: 'Máy chủ chính thức cần địa chỉ được mã hoá (https://).',
    accountHint: 'Mã tài khoản hoặc mã đại lý của Tino tại nhà cung cấp, nếu có. Không phải thông tin bí mật.',
    headerHint: 'Tên trường nhà cung cấp yêu cầu, ví dụ X-Api-Key.',
    credentialsElsewhere: 'Mật khẩu, mã truy cập và khoá được thiết lập ở thẻ Thông tin đăng nhập.',
    totalSessions_one: 'Tổng cộng {{count}} phiên cho mỗi dịch vụ đang chạy.',
    totalSessions_other: 'Tổng cộng {{count}} phiên cho mỗi dịch vụ đang chạy.',
    otherFieldsKept: 'Địa chỉ và thiết lập mã hoá được giữ nguyên.',
    settingsKept: 'Thời gian chờ và các nhóm phiên được giữ nguyên.',
  },
  settingsTab: {
    title: 'Thiết lập kết nối',
    description: 'Thời gian chờ, tạm dừng sau khi lỗi liên tiếp và số phiên dành cho từng loại công việc.',
    edit: 'Đổi thiết lập',
    configureFirst: 'Hãy nhập địa chỉ trước.',
    noLimit: 'Không giới hạn',
    failures_one: '{{count}} lỗi',
    failures_other: '{{count}} lỗi',
    pools: 'Nhóm phiên',
    poolsHint: 'Tách phiên riêng giúp công việc nền không làm chậm thao tác của khách hàng.',
    defaultPool: 'Chưa thiết lập: một phiên dùng chung (5 lệnh mỗi giây).',
    class: 'Loại công việc',
  },
  credentials: {
    title: 'Thông tin đăng nhập',
    descriptionEpp: 'Mã đăng nhập và mật khẩu Tino dùng để đăng nhập vào hệ thống của nhà quản lý tên miền. Mật khẩu không bao giờ được hiển thị. Phiên bản mới thay thế phiên bản đang dùng; phiên bản cũ vẫn nằm trong lịch sử.',
    descriptionRest: 'Thông tin Tino dùng để đăng nhập vào dịch vụ web của nhà cung cấp. Mật khẩu, mã truy cập và khoá không bao giờ được hiển thị. Phiên bản mới thay thế phiên bản đang dùng; phiên bản cũ vẫn nằm trong lịch sử.',
    add: 'Đặt thông tin đăng nhập mới',
    needsEnvironment: 'Hãy nhập địa chỉ trước.',
    restNotVerified: 'Hiện nền tảng chưa thể xác nhận thông tin đăng nhập này dùng được: việc kiểm tra chỉ xác nhận dịch vụ truy cập được.',
    none: 'Chưa có thông tin đăng nhập',
    clientId: 'Tên đăng nhập / mã ứng dụng',
    hidden: 'Ẩn (cần quyền quản lý thông tin đăng nhập)',
    secret: 'Mật khẩu hoặc khoá',
    revoke: 'Thu hồi',
    destroy: 'Huỷ giá trị',
    destroyWhat: 'Mật khẩu của thông tin đăng nhập phiên bản {{version}}',
  },
  credDialog: {
    title: 'Thông tin đăng nhập mới cho {{name}}',
    description: 'Được lưu thành phiên bản mới. Giá trị bạn nhập được mã hoá và không bao giờ hiển thị lại.',
    current: 'Phiên bản {{version}} đang được dùng.',
    none: 'Chưa có thông tin đăng nhập nào đang dùng.',
    eppClientId: 'Mã đăng nhập của nhà đăng ký',
    eppClientIdHint: '3–16 ký tự, theo mã nhà quản lý tên miền cấp.',
    eppClientIdInvalid: 'Phải có 3–16 ký tự.',
    eppPassword: 'Mật khẩu',
    eppPasswordHint: '6–16 ký tự. Chỉ thay đổi mật khẩu Tino dùng để đăng nhập; không đổi mật khẩu tại nhà quản lý tên miền.',
    eppPasswordInvalid: 'Mật khẩu phải có 6–16 ký tự.',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    token: 'Mã truy cập (token)',
    apiKey: 'Khoá truy cập',
    oauthClientId: 'Mã ứng dụng (client ID)',
    clientSecret: 'Khoá bí mật của ứng dụng',
    restHint: 'Nhập đúng thông tin nhà cung cấp đã cấp cho Tino.',
    keep: 'Giữ mật khẩu hiện tại',
    rotateProduction: 'Phiên bản đang dùng vẫn hoạt động cho đến khi phiên bản mới được phê duyệt và áp dụng.',
    rotateTest: 'Phiên bản mới thay thế phiên bản đang dùng ngay lập tức.',
  },
  certificates: {
    title: 'Chứng thư số',
    description: 'Chứng thư số và khoá bí mật Tino xuất trình khi kết nối tới nhà quản lý tên miền.',
    add: 'Chứng thư + khoá (tệp riêng)',
    none: 'Chưa có chứng thư số',
    noneHint: 'Tải lên chứng thư số cấp cho Tino nếu nhà quản lý tên miền yêu cầu.',
    requiredProduction: 'Kết nối chính thức bắt buộc có chứng thư số.',
    daysLeft_one: 'Còn {{count}} ngày',
    daysLeft_other: 'Còn {{count}} ngày',
    expired: 'Đã hết hạn',
    subject: 'Cấp cho',
    issuer: 'Cấp bởi',
    validity: 'Hiệu lực',
    serial: 'Số sê-ri',
    fingerprint: 'Dấu vân tay (SHA-256)',
    key: 'Khoá bí mật',
    destroyWhat: 'Khoá bí mật của chứng thư số phiên bản {{version}}',
  },
  certDialog: {
    title: 'Chứng thư số mới cho {{name}}',
    description: 'Nền tảng đọc chứng thư, kiểm tra thời hạn và kiểm tra khoá bí mật có khớp với chứng thư không.',
    pem: 'Chứng thư số (công khai)',
    pemHint: 'Dán nội dung chứng thư cấp cho Tino trước, sau đó là các chứng thư trung gian (nếu có).',
    pemInvalid: 'Hãy dán đầy đủ nội dung chứng thư, gồm cả dòng BEGIN và END.',
    key: 'Khoá bí mật',
    keepKey: 'Giữ khoá hiện tại (chứng thư gia hạn)',
    keyHint: 'Chọn tệp khoá; khoá được mã hoá khi lưu và không bao giờ hiển thị.',
  },
  revoke: {
    title: {
      credential: 'Thu hồi thông tin đăng nhập phiên bản {{version}}',
      certificate: 'Thu hồi chứng thư số phiên bản {{version}}',
    },
    bannerNote: 'Việc thu hồi có hiệu lực ngay, không cần phê duyệt.',
    description: 'Việc thu hồi có hiệu lực ngay, kể cả trên máy chủ chính thức, không cần phê duyệt, vì được dùng trong tình huống khẩn cấp. Thao tác được ghi nhận.',
    activeTitle: 'Phiên bản này đang được dùng',
    activeBody: {
      credential: 'Kết nối ngừng hoạt động ngay khi thu hồi, cho đến khi có thông tin đăng nhập mới có hiệu lực.',
      certificate: 'Kết nối ngừng hoạt động ngay khi thu hồi, cho đến khi có chứng thư số mới có hiệu lực.',
    },
    inactiveTitle: 'Phiên bản này không được dùng',
    inactiveBody: 'Sau khi thu hồi, phiên bản này không thể dùng được nữa.',
    confirmActive: 'Tôi hiểu kết nối sẽ ngừng hoạt động ngay.',
    confirm: 'Thu hồi phiên bản này.',
    submit: 'Thu hồi',
  },
  destroy: {
    title: 'Huỷ giá trị đã lưu',
    body: 'Giá trị được hệ thống lưu mã hoá sẽ bị xoá vĩnh viễn. Phiên bản vẫn giữ lịch sử nhưng không bao giờ dùng được nữa.',
    confirm: 'Xoá vĩnh viễn giá trị này.',
    submit: 'Huỷ giá trị',
  },
  editConnection: {
    title: 'Sửa {{name}}',
    description: 'Mã, loại và cách kết nối không thể thay đổi sau khi tạo.',
    inProductionTitle: 'Đang dùng trên máy chủ chính thức',
    inProduction: 'Thay đổi trạng thái, phần tích hợp hoặc thông tin nhà đăng ký trung gian được lưu thành đề xuất và cần người thứ hai phê duyệt. Nếu chỉ đổi tên hoặc tài liệu tham khảo thì có hiệu lực ngay; nếu đổi cùng lúc với các mục trên, toàn bộ thay đổi sẽ chờ phê duyệt.',
    statusHint: 'Kết nối đã ngừng sử dụng không thể được chọn cho TLD.',
    immutable: 'Mã, loại và cách kết nối là cố định.',
    willNeedApproval: 'Thay đổi này cần người thứ hai phê duyệt trước khi có hiệu lực.',
    appliesNow: 'Thay đổi này có hiệu lực ngay.',
  },
  versions: {
    version: 'Phiên bản',
    versionN: 'Phiên bản {{version}}',
    version0: '0 (thiết lập ban đầu)',
    version0Long: 'Thiết lập ngoài Control Center (phiên bản 0)',
    status: 'Trạng thái',
    enabled: 'Bật/tắt',
    endpoint: 'Địa chỉ',
    reason: 'Lý do',
    createdBy: 'Đề xuất',
    activated: 'Có hiệu lực từ',
    none: 'Chưa có phiên bản nào.',
    noneProvider: 'Chưa có cấu hình nào được lưu tại đây.',
  },
  history: {
    title: 'Lịch sử thay đổi',
    description: 'Mọi thay đổi, lần kiểm tra, phê duyệt và huỷ bỏ của kết nối này, mới nhất trước.',
    none: 'Chưa có thay đổi nào được ghi nhận.',
    withApproval: 'hai người duyệt',
    outcome: { SUCCESS: 'Hoàn tất', FAILED: 'Không thành công', DENIED: 'Bị từ chối' },
    actor: { SYSTEM: 'Hệ thống', EXTERNAL: 'Bên ngoài' },
    action: {
      integration_connection_create: 'Thêm kết nối',
      integration_connection_update: 'Đổi thông tin kết nối',
      integration_environment_propose: 'Đề xuất thay đổi cấu hình kết nối',
      integration_environment_activate: 'Thay đổi cấu hình kết nối có hiệu lực',
      integration_credential_propose: 'Đề xuất thông tin đăng nhập mới',
      integration_credential_activate: 'Thông tin đăng nhập mới có hiệu lực',
      integration_credential_revoke: 'Thu hồi thông tin đăng nhập',
      integration_certificate_propose: 'Đề xuất chứng thư số mới',
      integration_certificate_activate: 'Chứng thư số mới có hiệu lực',
      integration_certificate_revoke: 'Thu hồi chứng thư số',
      integration_tld_channel_propose: 'Đề xuất đổi kênh đăng ký TLD',
      integration_tld_channel_activate: 'Kênh đăng ký TLD mới có hiệu lực',
      integration_provider_setting_propose: 'Đề xuất đổi cấu hình VNNIC',
      integration_provider_setting_activate: 'Cấu hình VNNIC mới có hiệu lực',
      integration_sponsoring_registrar_propose: 'Đề xuất đổi nhà đăng ký quản lý',
      integration_sponsoring_registrar_activate: 'Nhà đăng ký quản lý mới có hiệu lực',
      integration_secret_store: 'Lưu mã hoá giá trị bí mật',
      integration_secret_destroy: 'Huỷ giá trị đã lưu',
      integration_change_apply: 'Áp dụng thay đổi đã phê duyệt',
      integration_change_cancel: 'Huỷ thay đổi',
      integration_connection_test: 'Kiểm tra kết nối',
      integration_ote_exercise_start: 'Bắt đầu chạy thử nghiệp vụ OT&E',
      integration_ote_exercise_finish: 'Kết thúc chạy thử nghiệp vụ OT&E',
      approval_request: 'Gửi yêu cầu phê duyệt',
      approval_decide: 'Quyết định phê duyệt',
      integration_balance_read: 'Xem số dư WebNIC',
      integration_certificate_import_pkcs12: 'Từ chối nhập tệp chứng thư',
    },
  },
  tlds: {
    guideTitle: 'Các kiểu kênh đăng ký là gì?',
    own: 'Kênh riêng của TLD',
    inherited: 'Theo mặc định: {{name}}',
    domainsVia_one: '{{formatted}} tên miền qua {{name}}',
    domainsVia_other: '{{formatted}} tên miền qua {{name}}',
    domainsViaMore: '{{formatted}} qua {{name}}',
    openTld: 'Mở trang .{{zone}}',
    title: 'Kênh đăng ký TLD',
    subtitle: 'Kết nối nào xử lý đăng ký mới và chuyển đến của từng TLD.',
    explainTitle: 'Tác động khi đổi kênh đăng ký',
    explain:
      'Chỉ đăng ký mới và chuyển đến dùng kết nối mới. Các tên miền đã đăng ký vẫn ở lại kết nối đang quản lý chúng (gia hạn và thay đổi vẫn đi qua kết nối đó) cho đến khi được chuyển đi. TLD chưa được chọn kênh sẽ dùng kết nối mặc định.',
    filter: {
      channel: 'Kênh đăng ký',
      connection: 'Kết nối',
      source: 'Cách chọn',
      class: 'Loại TLD',
      search: 'TLD',
      searchPlaceholder: 'vd. com, vn',
    },
    col: { tld: 'TLD', kind: 'Kiểu kênh', connection: 'Kết nối cho đăng ký mới', source: 'Cách chọn', channel: 'Kênh đăng ký', domains: 'Tên miền đang quản lý', actions: 'Thao tác' },
    loading: 'Đang tải danh sách TLD…',
    loadFailed: 'Không tải được kênh đăng ký TLD',
    empty: 'Không có TLD phù hợp với bộ lọc.',
    noAdapter: 'Chưa thể đăng ký tự động',
    notReady: 'Kết nối chưa sẵn sàng',
    pending: 'Có thay đổi đang chờ',
    change: 'Đổi kênh đăng ký',
    history: 'Lịch sử',
    noDomains: 'Không có',
    selectAll: 'Chọn tất cả TLD trên trang này',
    select: 'Chọn .{{zone}}',
    batch_one: 'Đổi kênh đăng ký cho {{count}} TLD',
    batch_other: 'Đổi kênh đăng ký cho {{count}} TLD',
  },
  channelDialog: {
    title: 'Kênh đăng ký của .{{zone}}',
    description: 'Chọn kết nối dùng cho đăng ký mới và chuyển đến của TLD này.',
    currentLabel: 'Hiện tại',
    current: 'Đang dùng',
    newConnection: 'Kết nối mới',
    newChannel: 'Kênh mới:',
    scopeTitle: 'Tên miền hiện có không bị chuyển',
    scope: 'Chỉ đăng ký mới và chuyển đến dùng kết nối mới. Các tên miền đã đăng ký vẫn ở lại kết nối đang quản lý chúng.',
    scopeDomains_one: 'Chỉ đăng ký mới và chuyển đến dùng kết nối mới. {{formatted}} tên miền đã đăng ký vẫn ở lại {{name}}.',
    scopeDomains_other: 'Chỉ đăng ký mới và chuyển đến dùng kết nối mới. {{formatted}} tên miền đã đăng ký vẫn ở lại {{name}}.',
    checks: 'Trước khi tiếp tục',
    sponsorCheck: 'Với gTLD, báo cáo gửi VNNIC cần có nhà đăng ký quản lý của kết nối này (trang VNNIC).',
    pendingExists: 'Đã có một thay đổi kênh đăng ký đang chờ phê duyệt. Hãy phê duyệt, áp dụng hoặc huỷ nó trước.',
    applied: 'Từ bây giờ, đăng ký mới và chuyển đến của TLD này đi qua kết nối mới.',
  },
  batchDialog: {
    title_one: 'Đổi kênh đăng ký cho {{count}} TLD',
    title_other: 'Đổi kênh đăng ký cho {{count}} TLD',
    description: 'Tất cả TLD đã chọn chuyển sang cùng một kết nối, chỉ cần một lần phê duyệt trên máy chủ chính thức.',
    tlds: 'Các TLD đã chọn',
    skipHint: 'Các TLD đã dùng kết nối này, đang có thay đổi chờ duyệt hoặc đã ngừng sử dụng sẽ được bỏ qua.',
    included_one: 'Bao gồm {{count}} TLD.',
    included_other: 'Bao gồm {{count}} TLD.',
    skipped_one: 'Bỏ qua {{count}} TLD',
    skipped_other: 'Bỏ qua {{count}} TLD',
    skip: {
      SAME_CONNECTION: 'đang dùng kết nối này',
      PENDING_CHANGE_EXISTS: 'đã có thay đổi đang chờ',
      TLD_RETIRED: 'đã ngừng sử dụng',
    },
  },
  tldHistory: {
    defaultOf: 'Kết nối mặc định của .{{zone}}',
    title: 'Lịch sử kênh đăng ký của .{{zone}}',
    description: 'Mọi lựa chọn kênh đăng ký của TLD này, mới nhất trước.',
    inline: 'Lịch sử kênh đăng ký',
    default: 'Kết nối mặc định',
    connection: 'Kết nối',
    none: 'Chưa từng chọn kênh đăng ký',
    noneHint: 'TLD này luôn dùng kết nối mặc định.',
  },
  vnnic: {
    title: 'Tích hợp VNNIC',
    subtitle: 'Registrar API, eKYC, dịch vụ hồ sơ (HSTM) và báo cáo gTLD của máy chủ này.',
    catalogFailed: 'Không tải được danh sách dịch vụ VNNIC',
    unknownProvider: 'Phiên bản này chưa hỗ trợ dịch vụ này.',
    loadFailed: 'Không tải được cấu hình này',
    usedBy: 'Được dùng bởi:',
    fromEnvTitle: 'Vẫn đang dùng cấu hình trên máy chủ',
    fromEnv: 'Chưa có cấu hình nào lưu tại đây, nên các dịch vụ dùng giá trị cấu hình trên máy chủ (biến môi trường), nếu có. Khi bạn lưu cấu hình tại đây, cấu hình này sẽ thay thế giá trị trên máy chủ.',
    someOnEnv: 'Một số dịch vụ vẫn dùng cấu hình trên máy chủ; chúng sẽ chuyển sang cấu hình lưu tại đây trong khoảng {{seconds}} giây.',
    restartTitle: 'Cần khởi động lại',
    restart: 'Việc bật/tắt dịch vụ này chỉ có hiệu lực sau khi các dịch vụ khởi động lại. Trước đó, chúng vẫn hoạt động như cũ.',
    settingsTitle: 'Cấu hình',
    edit: 'Đổi cấu hình',
    configure: 'Thiết lập tại đây',
    test: 'Kiểm tra truy cập',
    preset: 'Địa chỉ VNNIC công bố cho {{env}}:',
    noPreset: 'VNNIC chưa công bố địa chỉ cho {{env}}; hãy nhập địa chỉ VNNIC đã cấp cho Tino.',
    matchesPreset: 'Khớp với địa chỉ VNNIC công bố',
    differsFromPreset: 'Khác với địa chỉ VNNIC công bố',
    notConfigured: 'Chưa thiết lập trên {{env}}',
    notConfiguredHint: 'Thiết lập tại đây để quản lý từ Control Center.',
    applied: 'Các dịch vụ',
    appliedHint: 'Cấu hình mà từng dịch vụ đang chạy sử dụng.',
    testsHint: 'Chỉ kiểm tra dịch vụ có truy cập được không; không gửi thông tin đăng nhập hay dữ liệu cá nhân.',
    testsHintLogin: 'Kiểm tra khả năng truy cập không gửi thông tin đăng nhập; kiểm tra đăng nhập dùng mã ứng dụng và khoá bí mật đã lưu cho một lệnh chỉ đọc. Không gửi dữ liệu cá nhân.',
    secrets: 'Mật khẩu và khoá',
  },
  providerDialog: {
    title: 'Thay đổi cấu hình: {{name}}',
    description: 'Được lưu thành phiên bản mới; phiên bản cũ vẫn nằm trong lịch sử. Mật khẩu và khoá không bao giờ hiển thị lại.',
    firstTime: 'Trước đây các dịch vụ dùng cấu hình trên máy chủ. Khi lưu tại đây, cấu hình mới sẽ thay thế.',
    enabled: 'Bật dịch vụ này',
    advanced: 'Thiết lập nâng cao',
    pathHint: 'Mặc định: {{value}}',
    keep: 'Giữ giá trị hiện tại',
    secretRequired: 'Bắt buộc khi bật dịch vụ; có thể để trống khi dịch vụ đang tắt.',
    secretPermission: 'Đổi mật khẩu hoặc khoá cần quyền quản lý thông tin đăng nhập; trên máy chủ chính thức, người phê duyệt cũng cần quyền này.',
  },
  sponsor: {
    title: 'Nhà đăng ký quản lý (báo cáo gTLD)',
    description: 'Nhà đăng ký được công nhận được ghi cho từng kết nối trong báo cáo tên miền quốc tế gửi VNNIC.',
    connection: 'Kết nối',
    sourceLabel: 'Nguồn',
    source: { UPSTREAM_REGISTRAR: 'Thông tin nhà đăng ký trung gian', MAPPING: 'Công nhận của Tino', MISSING: 'Chưa có' },
    iana: 'Mã IANA',
    name: 'Tên nhà đăng ký',
    zones: 'gTLD (chính thức)',
    domains: 'Tên miền gTLD',
    set: 'Thiết lập',
    edit: 'Thay đổi',
    fromUpstream: 'Sửa trên trang kết nối',
    missing: 'Một số kết nối chưa có nhà đăng ký quản lý: báo cáo gửi VNNIC sẽ bỏ qua các tên miền gTLD của chúng cho đến khi được thiết lập.',
    none: 'Không có kết nối nào xử lý gTLD.',
    dialogTitle: 'Nhà đăng ký quản lý của {{name}}',
    dialogDescription: 'Mã IANA và tên nhà đăng ký gửi cho VNNIC đối với các tên miền quản lý qua kết nối này.',
    alwaysApproval: 'Luôn cần người thứ hai phê duyệt',
    alwaysApprovalBody: 'Thay đổi này ảnh hưởng tới báo cáo chính thức, nên mọi thay đổi đều cần người thứ hai phê duyệt trước khi được áp dụng.',
    confirm: 'Tôi đã đối chiếu mã IANA và tên với thông tin công nhận.',
  },
  webnic: {
    allowListTitle: 'WebNIC chỉ nhận yêu cầu từ địa chỉ máy chủ đã được cho phép',
    allowList: 'WebNIC chỉ trả lời yêu cầu đến từ các địa chỉ IP trong danh sách cho phép của tài khoản. Yêu cầu từ địa chỉ khác bị từ chối giống như sai tên người dùng hoặc khoá bí mật.',
    allowListHow: 'Trong cổng đối tác WebNIC, hãy thêm địa chỉ IP công khai (chiều đi) của từng máy chủ Tino làm việc với WebNIC vào danh sách IP cho phép: máy chủ OT&E vào tài khoản thử nghiệm, máy chủ chính thức vào tài khoản chính thức. Hãy hỏi nhóm nền tảng để biết các địa chỉ này.',
    authHint: 'Tino đăng nhập bằng tên người dùng và khoá bí mật WebNIC đặt ở thẻ Thông tin đăng nhập, và tự gia hạn quyền truy cập.',
    authMethod: 'Tên người dùng và khoá bí mật WebNIC',
    username: 'Tên người dùng API WebNIC',
    secret: 'Khoá bí mật API WebNIC',
    credentialHint: 'Tên người dùng và khoá bí mật lấy từ cổng đối tác WebNIC; máy chủ OT&E dùng tài khoản thử nghiệm, máy chủ chính thức dùng tài khoản chính thức.',
    keepSecret: 'Giữ khoá bí mật hiện tại',
    overviewTitle: 'WebNIC',
    overview: 'Trang này cho xem số dư tài khoản WebNIC và kiểm tra đăng nhập. Đăng ký tên miền thuộc đuôi có kênh WebNIC được gửi sang WebNIC tự động.',
    createTitle: 'WebNIC cần những gì',
    createAddresses: 'Địa chỉ (được gợi ý khi thiết lập kết nối):',
    createAuth: 'Đăng nhập: tên người dùng và khoá bí mật WebNIC, đặt ở thẻ Thông tin đăng nhập.',
    createIana: 'Nhập mã nhà đăng ký IANA của WebNIC theo danh sách nhà đăng ký của IANA; mã này được gửi cho VNNIC trong báo cáo gTLD.',
  },
  balance: {
    title: 'Số dư tài khoản',
    description: 'Số tiền còn lại trong tài khoản của Tino tại nhà cung cấp này. Việc xem số dư không thay đổi gì ở nhà cung cấp.',
    loading: 'Đang hỏi nhà cung cấp…',
    refresh: 'Làm mới',
    refreshIn_one: 'Có thể làm mới sau {{count}} giây',
    refreshIn_other: 'Có thể làm mới sau {{count}} giây',
    empty: 'Nhà cung cấp không báo số dư nào cho tài khoản này.',
    fetchedAt: 'Cập nhật lúc {{when}} ({{ago}}).',
    cached: 'Nhà cung cấp chỉ được hỏi tối đa mỗi phút một lần; đây là câu trả lời gần nhất.',
    unavailable: {
      notConfigured: 'Hãy thiết lập địa chỉ, tên người dùng và khoá bí mật WebNIC trước.',
    },
    error: {
      notConfiguredServer: 'Số dư và danh sách tên miền {{provider}} được lấy qua Registrar API của VNNIC, cấu hình riêng cho máy chủ (địa chỉ, client id, secret), chưa được thiết lập hoặc chưa bật.',
      openProviderSettings: 'Mở cài đặt Registrar API VNNIC',
      authFailedVnnic: 'Hãy kiểm tra client id và secret của Registrar API VNNIC trong phần cài đặt nhà cung cấp, và địa chỉ IP của máy chủ này đã được đăng ký với VNNIC.',
      failed: 'Không đọc được số dư',
      AUTH_FAILED: '{{provider}} từ chối đăng nhập',
      UNAVAILABLE: 'Không kết nối được tới {{provider}}',
      NOT_CONFIGURED: 'Chưa dùng được cấu hình {{provider}}',
      NOT_SUPPORTED: 'Nhà cung cấp của kết nối này không có chức năng này',
      FORBIDDEN: 'Bạn không có quyền xem cấu hình tích hợp',
      NOT_FOUND: 'Kết nối này không còn tồn tại',
      authFailedBody: 'Hãy kiểm tra tên người dùng và khoá bí mật {{provider}} ở thẻ Thông tin đăng nhập. Nếu các giá trị đúng, nhiều khả năng địa chỉ của máy chủ này chưa có trong danh sách IP cho phép của {{provider}}.',
      unavailableBody: '{{provider}} không trả lời kịp hoặc trả lời không như mong đợi. Không có gì bị thay đổi; hãy thử lại sau ít phút.',
      notConfiguredBody: 'Hãy kiểm tra địa chỉ, tên người dùng và khoá bí mật {{provider}}.',
      when: '{{provider}} được hỏi lúc {{when}}.',
    },
  },
  places: {
    title: 'Danh mục địa chỉ VNNIC',
    description: 'Tỉnh/thành và xã/phường theo danh mục hai cấp VNNIC kiểm tra khi nhận liên hệ. Mọi địa chỉ chủ thể được chọn và đối chiếu theo danh mục này. Máy chủ tự đồng bộ từ VNNIC mỗi ngày.',
    counts: '{{provinces}} tỉnh/thành, {{wards}} xã/phường đang dùng.',
    fromVnnic: 'Đã đồng bộ từ VNNIC',
    fromSeed: 'Danh mục quốc gia (chưa đồng bộ từ VNNIC)',
    seedHint: 'Đang dùng danh mục quốc gia có sẵn. Hãy đồng bộ từ VNNIC để tên và mã khớp đúng với VNNIC (cần Registrar API đăng nhập được).',
    syncNow: 'Đồng bộ ngay từ VNNIC',
    syncCounts: '{{provinces}} tỉnh, {{wards}} xã/phường, {{retired}} mục ngưng dùng',
    automatic: 'tự động',
    outcome: { RUNNING: 'Đang chạy', SUCCEEDED: 'Thành công', FAILED: 'Không thành công' },
    error: {
      AUTH_FAILED: 'VNNIC từ chối mã ứng dụng / khoá bí mật',
      UNAVAILABLE: 'Không kết nối được VNNIC',
      UNREADABLE_ANSWER: 'VNNIC trả lời không đúng dạng',
      IMPLAUSIBLE_LIST: 'Danh mục VNNIC trả về thiếu bất thường nên không áp dụng',
      DATABASE: 'Lỗi lưu dữ liệu',
    },
  },
  accountBlock: { title: 'Tài khoản tại nhà cung cấp', openConnection: 'Mở trang kết nối' },
  accountDomains: {
    title: 'Tên miền nhà cung cấp đang ghi nhận',
    description: 'Danh sách tên miền nhà cung cấp ghi nhận cho Tino, đối chiếu với tên miền của kết nối này trong hệ thống.',
    loading: 'Đang lấy danh sách tên miền…',
    fetchedAt: 'Lấy lúc {{when}}.',
    keptNote: 'Máy chủ giữ danh sách này 10 phút để chuyển trang, lọc và tìm không phải hỏi lại nhà cung cấp. Bấm Làm mới để lấy lại.',
    summary: { atProvider: 'Tại nhà cung cấp', inBoth: 'Đã có trong hệ thống', onlyProvider: 'Chưa có trong hệ thống', onlyPlatform: 'Chỉ có trong hệ thống' },
    onlyProviderHint: 'Có {{count}} tên miền nhà cung cấp ghi nhận cho Tino nhưng chưa có trong hệ thống (thường là tên miền còn quản lý ở hệ thống cũ). Cần đưa chúng vào hệ thống để gia hạn và quản lý.',
    filter: { all: 'Tất cả', only_provider: 'Chưa có trong hệ thống', in_both: 'Đã có trong hệ thống', only_platform: 'Chỉ có trong hệ thống' },
    search: 'Tìm tên miền',
    empty: 'Không có tên miền nào khớp.',
    notInPlatform: 'Chưa có trong hệ thống',
    notAtProvider: 'Nhà cung cấp không liệt kê',
    col: { name: 'Tên miền', type: 'Loại', created: 'Ngày đăng ký', expires: 'Ngày hết hạn', platform: 'Trong hệ thống', actions: 'Thao tác' },
    page: 'Trang {{page}}/{{pages}} · {{from}}–{{to}} trên {{total}} tên miền',
    select: 'Chọn {{name}}',
    selectPage: 'Chọn mọi tên miền chưa có trong hệ thống ở trang này',
    selected: 'Đã chọn {{count}} tên miền',
    clearSelection: 'Bỏ chọn',
    importOne: 'Đưa vào hệ thống',
    importSelected: 'Đưa {{count}} tên miền vào hệ thống',
    viewRegistry: 'Xem tại registry',
    preview: {
      title: '{{name}} tại registry',
      description: 'Đọc trực tiếp tại registry (domain:info và liên hệ chủ thể), không thay đổi gì.',
      loading: 'Đang đọc tại registry…',
      readAt: 'Đọc lúc {{when}}.',
      notFound: 'Registry không có tên miền này.',
      roid: 'ROID',
      sponsor: 'Nhà đăng ký quản lý',
      sponsoredByUs: 'Tino ({{sponsor}})',
      sponsoredByOther: 'Nhà đăng ký khác ({{sponsor}})',
      created: 'Ngày đăng ký',
      expires: 'Ngày hết hạn',
      statuses: 'Trạng thái tại registry',
      nameservers: 'Máy chủ tên',
      registrant: 'Mã liên hệ chủ thể',
      contacts: 'Liên hệ khác',
      subject: 'Chủ thể trong hệ thống',
      openSubject: 'Mở chủ thể',
      subjectHostbill: 'Chủ thể nhập từ eKYC HostBill, chưa gắn khách hàng: khi đưa vào, chủ thể được gắn vào khách hàng đã chọn.',
      subjectManagedBy: 'Chủ thể do khách {{customer}} quản lý: chỉ đưa được vào tài khoản khách này.',
      importable: 'Có thể đưa vào hệ thống: tên miền thuộc Tino, còn hạn và không ở trạng thái chờ.',
      inPlatform: 'Tên miền đã có trong hệ thống.',
      openDomain: 'Mở tên miền',
      close: 'Đóng',
    },
    match: {
      MATCHED: 'Khớp đúng một chủ thể theo số giấy tờ registry ghi cho chủ thể tên miền.',
      AMBIGUOUS: 'Có {{count}} chủ thể cùng số giấy tờ registry ghi: cần chọn chủ thể.',
      NOT_MATCHED: 'Chưa chủ thể nào có số giấy tờ registry ghi: khi đưa vào, hệ thống tạo chủ thể mới từ dữ liệu registry (chưa xác minh), hoặc chọn một chủ thể của khách.',
      NO_IDENTITY: 'Registry không ghi số giấy tờ cho chủ thể tên miền: khi đưa vào, hệ thống tạo chủ thể từ dữ liệu registry (chưa xác minh), hoặc chọn một chủ thể của khách.',
      UNSUPPORTED: 'Registry này không cho đọc giấy tờ của liên hệ: cần chọn chủ thể.',
      UNAVAILABLE: 'Chưa đọc được liên hệ tại registry ({{outcome}}): cần chọn chủ thể hoặc thử lại.',
    },
    import: {
      title: 'Đưa {{count}} tên miền vào hệ thống',
      description: 'Với từng tên miền, nền tảng đọc lại tại registry rồi tạo bản ghi theo dữ liệu registry (ROID, nhà đăng ký, ngày đăng ký, ngày hết hạn, trạng thái, máy chủ tên), gắn khách hàng và chủ thể, ghi liên hệ chủ thể/quản lý/kỹ thuật/thanh toán với mã liên hệ hiện có tại registry. Chủ thể chưa thuộc khách nào (nhập từ eKYC HostBill) được gắn vào khách hàng này; chủ thể chưa có thì được tạo từ dữ liệu registry. Không gửi lệnh nào tới registry, không thu tiền.',
      states: 'Tên miền nhận trạng thái Đang hoạt động; tự động gia hạn tắt và chưa tính phí; hồ sơ được mở với chủ thể đã gắn và chờ nhân viên hoàn thiện.',
      customer: 'Khách hàng sở hữu',
      registrant: 'Chủ thể đăng ký',
      registrantAuto: 'Tự khớp theo số giấy tờ registry ghi cho chủ thể',
      registrantChoose: 'Chọn một chủ thể của khách hàng',
      bulkAutoOnly: 'Khi đưa nhiều tên miền, chủ thể được tự khớp cho từng tên miền (không khớp thì tạo từ dữ liệu registry). Tên miền có nhiều chủ thể cùng số giấy tờ sẽ báo lỗi; đưa riêng tên miền đó và chọn chủ thể.',
      noSubjects: 'Khách hàng chưa có chủ thể.',
      chooseSubject: 'Chọn chủ thể',
      reason: 'Lý do',
      reasonHint: 'Ghi vào nhật ký thao tác.',
      submit: 'Đưa vào hệ thống',
      running: 'Đang xử lý {{done}}/{{total}}…',
      finished: 'Xong: {{ok}} thành công, {{failed}} lỗi.',
      retry: 'Thử lại {{count}} tên miền lỗi',
      close: 'Đóng',
      waiting: 'Chờ',
      working: 'Đang xử lý',
      openDomain: 'Mở tên miền',
    },
    importAll: {
      button: 'Đưa tất cả vào hệ thống',
      title: 'Đưa tất cả tên miền chưa có vào hệ thống',
      description:
        'Máy chủ đưa lần lượt từng tên miền nhà cung cấp ghi nhận cho Tino mà hệ thống chưa có vào tài khoản khách hàng được chọn, chạy nền theo từng lô: không cần giữ trang mở. Mỗi tên miền được đọc lại tại registry, gắn chủ thể (khớp theo số giấy tờ, hoặc tạo từ dữ liệu registry) và ghi liên hệ với mã liên hệ hiện có tại registry. Không gửi lệnh tới registry, không thu tiền, không gửi thông báo cho khách.',
      count: 'Sẽ xử lý {{count}} tên miền chưa có trong hệ thống (theo danh sách lấy lúc {{when}}).',
      skipNote:
        'Tên miền hết hạn, đang chờ xoá, chờ chuộc, chờ chuyển hoặc chưa tạo xong; có nhiều chủ thể cùng số giấy tờ; hoặc chủ thể thuộc khách khác sẽ được bỏ qua kèm lý do. Chạy lại an toàn: tên đã có được bỏ qua. Tự động gia hạn tắt.',
      customer: 'Khách hàng nhận tất cả tên miền',
      submit: 'Bắt đầu',
      panelTitle: 'Đưa tất cả vào hệ thống',
      state: {
        PENDING: 'Chờ chạy',
        RUNNING: 'Đang chạy',
        WAITING: 'Đang chờ registry',
        RETRYING: 'Đang thử lại',
        COMPLETED: 'Đã xong',
        FAILED: 'Dừng do lỗi',
        MANUAL_REVIEW: 'Dừng, cần nhân viên xem',
        CANCELLED: 'Đã huỷ',
      },
      progress: 'Đã xử lý {{done}}/{{total}} tên miền',
      imported: 'Đã nhập',
      skipped: 'Bỏ qua',
      failed: 'Lỗi',
      remaining: 'Còn lại',
      meta: 'Khách hàng {{customer}} · bắt đầu {{when}}',
      finishedAt: 'Xong lúc {{when}}.',
      byReason: 'Theo lý do',
      issues: 'Tên miền bỏ qua hoặc lỗi gần nhất ({{count}})',
      outcome: { SKIPPED: 'Bỏ qua', FAILED: 'Lỗi' },
      rerunHint: 'Bấm Đưa tất cả vào hệ thống lần nữa để thử lại tên lỗi hoặc còn thiếu: tên đã có được bỏ qua.',
      failure: 'Dừng: {{message}}',
    },
  },
  pkcs12: {
    caInFile: 'Tệp có kèm {{count}} chứng thư CA chưa được dùng để xác minh máy chủ',
    caInFileHint: 'Nhà quản lý tên miền thường cấp Root CA trong cùng tệp. Dùng làm Root CA để Tino tin cậy máy chủ của họ (đối chiếu dấu vân tay nếu nhà quản lý công bố).',
    noCaInFile: 'Tệp không kèm chứng thư CA. Nếu kiểm tra kết nối báo máy chủ không được tin cậy, hãy tải Root CA nhà quản lý tên miền gửi ở mục Root CA.',
    caAlreadyTrusted: 'Các CA trong tệp đã được dùng làm Root CA.',
    open: 'Tải lên tệp .p12 / .pfx',
    title: 'Tải lên tệp chứng thư cho {{name}}',
    description: 'Tệp .p12 hoặc .pfx chứa khoá bí mật, chứng thư cấp cho Tino và chuỗi chứng thư. Nền tảng mở tệp, kiểm tra thời hạn và việc khoá khớp với chứng thư, rồi lưu khoá ở dạng mã hoá.',
    replaces: 'Chứng thư mới sẽ thay phiên bản {{version}} khi được áp dụng.',
    first: 'Đây sẽ là chứng thư máy khách đầu tiên của kết nối này.',
    file: 'Tệp chứng thư (.p12 / .pfx)',
    fileHint: 'Tối đa 64 KB. Tệp được gửi tới nền tảng qua kết nối mã hoá và không được giữ lại trong trình duyệt.',
    choose: 'Chọn tệp…',
    chooseOther: 'Chọn tệp khác…',
    noFile: 'Chưa chọn tệp',
    tooLarge: 'Tệp này lớn hơn 64 KB; tệp chứng thư máy khách thường chỉ vài KB.',
    passphrase: 'Mật khẩu của tệp',
    passphraseHint: 'Mật khẩu được đặt khi xuất tệp. Chỉ dùng một lần để mở tệp và không bao giờ được lưu.',
    passphraseCleared: 'Để an toàn, ô mật khẩu đã được xoá; hãy nhập lại để thử lần nữa.',
    productionNote: 'Trên máy chủ chính thức, chứng thư được lưu thành đề xuất; chỉ được dùng sau khi người thứ hai phê duyệt và có người áp dụng.',
    testNote: 'Trên máy chủ này, chứng thư mới được dùng ngay.',
    submit: 'Tải lên và sử dụng',
    applied: 'Chứng thư đã được áp dụng. Các dịch vụ sẽ nhận trong vòng một phút.',
    summaryTitle: 'Nội dung của tệp',
    keyType: 'Loại khoá',
    chainLength: 'Số chứng thư được lưu',
    chainCount_one: '{{count}} chứng thư',
    chainCount_other: '{{count}} chứng thư (kèm chuỗi chứng thư)',
    versionState: 'Kết quả',
    stateApplied: 'Phiên bản {{version}} đang được áp dụng',
    statePending: 'Phiên bản {{version}} đang chờ phê duyệt',
  },
  vnnicPreset: {
    title: 'Địa chỉ của VNNIC cho {{env}}',
    tls: 'mã hoá, dùng chứng thư máy khách',
    inUseHint: 'Kết nối đang dùng địa chỉ của VNNIC. Hãy tải lên bên dưới tệp chứng thư VNNIC đã cấp.',
    differentHint: 'Kết nối đang dùng địa chỉ khác. Hãy chuyển sang địa chỉ của VNNIC trước khi tải lên chứng thư của VNNIC.',
    missingHint: 'Hãy thiết lập kết nối với địa chỉ của VNNIC trước, sau đó tải lên tệp chứng thư VNNIC đã cấp.',
    setUp: 'Dùng địa chỉ của VNNIC',
  },
  certFiles: {
    threeFiles: 'Nhà quản lý tên miền thường cấp 3 tệp riêng: chứng thư (.crt), khoá bí mật (.key, có thể có mật khẩu) và Root CA của họ. Chứng thư và khoá nhập ở đây; Root CA nhập ở mục Root CA bên dưới trang Chứng thư số.',
    loadCertificate: 'Chọn tệp chứng thư (.crt / .cer / .pem)',
    loadKey: 'Chọn tệp khoá bí mật (.key / .pem)',
    keyPassword: 'Mật khẩu của khoá bí mật',
    keyPasswordHint: 'Khoá này được bảo vệ bằng mật khẩu. Khoá được mở một lần khi lưu rồi cất giữ đã mã hoá; mật khẩu không được lưu.',
    unreadable: 'Không đọc được tệp (tối đa 64 KB).',
  },
  rootCa: {
    fromChainTitle: 'Chứng thư đang dùng có kèm {{count}} chứng thư CA',
    fromChainBody: 'Tệp .p12 nhà quản lý tên miền cấp thường chứa luôn Root CA của họ. Có thể dùng các CA này để xác minh máy chủ thay vì tải tệp riêng.',
    fromChain: 'Dùng CA từ chứng thư đã tải',
    title: 'Root CA của nhà quản lý tên miền',
    description: 'Chứng thư CA dùng để xác minh máy chủ của nhà quản lý tên miền (ví dụ VNNIC). Cần khi máy chủ dùng CA riêng, không nằm trong danh sách CA công cộng.',
    none: 'Chưa khai báo Root CA',
    noneHint: 'Chỉ các CA công cộng được tin cậy. Nếu kiểm tra kết nối báo “chứng thư của máy chủ không được tin cậy”, hãy tải Root CA nhà quản lý tên miền cấp.',
    add: 'Tải lên Root CA',
    replace: 'Thay Root CA',
    root: 'CA gốc',
    intermediate: 'CA trung gian',
    dialogTitle: 'Root CA của {{name}}',
    dialogDescription: 'Lưu thành phiên bản mới của cấu hình kết nối; phiên bản cũ vẫn nằm trong lịch sử.',
    explain: 'Dán hoặc chọn tệp CA (.crt / .cer / .pem, có thể nhiều chứng thư). Để trống để chỉ tin cậy các CA công cộng.',
    pem: 'Chứng thư CA',
    pemHint: 'Chỉ là chứng thư công khai, không phải khoá bí mật.',
    emptyHint: 'Để trống: chỉ tin cậy các CA công cộng.',
    loadFile: 'Chọn tệp Root CA',
    needsEnvironment: 'Hãy nhập địa chỉ trước.',
  },
  email: {
    crumb: 'Cấu hình tích hợp',
    pageTitle: 'E-mail & mẫu thư',
    pageSubtitle: 'Cách gửi và nội dung các thông báo tới chủ thể và khách hàng. Khách hàng có hạng cho phép có thể gửi bằng thương hiệu riêng ở trang khách hàng.',
    platformTitle: 'Cấu hình gửi thư (hệ thống)',
    platformDescription: 'Dùng cho mọi khách hàng, trừ khách có hạng cho phép cấu hình riêng và đã lưu cấu hình đó.',
    customerTitle: 'Cấu hình gửi thư của khách hàng',
    customerDescription: 'Thư về tên miền và dịch vụ của khách hàng này được gửi từ máy chủ và địa chỉ riêng, mang thương hiệu của khách.',
    sendingWith: {
      OWN: 'Đang gửi bằng cấu hình này',
      PLATFORM: 'Đang gửi bằng cấu hình hệ thống',
      NONE: 'Chưa gửi được thư',
    },
    lastSaved: 'Lưu lần cuối {{when}} bởi {{who}}',
    usesPlatform: 'Khách hàng chưa có cấu hình riêng: thư được gửi bằng cấu hình hệ thống, dùng mẫu thư và thương hiệu riêng nếu có.',
    noneYet: 'Chưa có cấu hình: thư sẽ chờ cho đến khi lưu cấu hình ở đây hoặc ở hệ thống.',
    platformMissing: 'Chưa có cấu hình gửi thư: thông báo được xếp hàng nhưng chưa gửi cho đến khi bạn lưu cấu hình.',
    enabled: 'Gửi e-mail',
    enabledHint: 'Tắt: với hệ thống, thông báo không được gửi; với khách hàng, dùng cấu hình hệ thống.',
    server: 'Máy chủ gửi thư (SMTP)',
    host: 'Máy chủ',
    port: 'Cổng',
    security: 'Mã hoá',
    securities: {
      STARTTLS: 'STARTTLS (cổng 587)',
      TLS: 'TLS (cổng 465)',
      NONE: 'Không (chỉ relay nội bộ)',
    },
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    passwordSaved: 'Đã lưu mật khẩu (không bao giờ hiển thị).',
    passwordNone: 'Chưa lưu mật khẩu.',
    passwordKeep: 'Giữ mật khẩu đã lưu',
    passwordReplace: 'Thay mật khẩu',
    passwordSet: 'Đặt mật khẩu',
    passwordClear: 'Xoá mật khẩu',
    newPassword: 'Mật khẩu mới',
    sender: 'Người gửi',
    fromName: 'Tên người gửi',
    fromAddress: 'Địa chỉ gửi',
    replyTo: 'Địa chỉ nhận trả lời',
    bcc: 'Gửi bản sao mọi thư tới',
    bccHint: 'Không bắt buộc, ví dụ hộp thư lưu trữ.',
    brand: 'Thương hiệu hiển thị trong thư',
    brandFields: {
      name: 'Tên thương hiệu',
      website: 'Website',
      support_email: 'E-mail hỗ trợ',
      support_phone: 'Điện thoại hỗ trợ',
      logo_url: 'Đường dẫn logo (https)',
      primary_color: 'Màu chủ đạo',
      address: 'Địa chỉ',
      footer: 'Chân thư',
      action_base_url: 'Địa chỉ cho liên kết xác nhận',
    },
    actionBaseHint: 'Không bắt buộc: nơi các liên kết trong thư trỏ tới (phải phục vụ /confirm/…). Để trống: địa chỉ hệ thống.',
    save: 'Lưu cấu hình',
    saved: 'Đã lưu cấu hình.',
    testTo: 'Gửi thư thử tới',
    sendTest: 'Gửi thử',
    testSent: 'Máy chủ đã nhận thư thử: {{answer}}',
    tpl: {
      title: 'Mẫu thư',
      descriptionPlatform: 'Mọi thông báo đều có sẵn mẫu tiếng Việt và tiếng Anh; bạn có thể sửa bất kỳ mẫu nào theo thương hiệu.',
      descriptionCustomer: 'Mẫu thư riêng của khách hàng; mẫu nào không sửa sẽ dùng mẫu của hệ thống (hoặc mẫu có sẵn).',
      notice: 'Thông báo',
      edit: 'Sửa',
      sources: {
        CUSTOMER: 'Của khách hàng',
        PLATFORM: 'Của hệ thống',
        BUILT_IN: 'Có sẵn',
      },
      sourceNote: {
        CUSTOMER: 'Bản riêng của khách hàng này.',
        PLATFORM: 'Bản của hệ thống: lưu sẽ tạo bản riêng.',
        BUILT_IN: 'Bản có sẵn: lưu sẽ tạo bản riêng.',
      },
      subject: 'Tiêu đề',
      html: 'Nội dung HTML',
      htmlHint: 'Được đặt vào khung thư. Biến được tự động thoát ký tự HTML.',
      layoutHint: 'Phải có {{ content }} ở chỗ đặt nội dung từng thông báo.',
      text: 'Nội dung dạng chữ',
      variables: 'Biến: {{ domain }}, {{ recipient_name }}, {{ brand.name }}, {{ brand.support_email }}… và các biến riêng của từng thông báo (xem mẫu có sẵn). Điều kiện: {% if x %}…{% endif %}.',
      refreshPreview: 'Cập nhật xem trước',
      preview: 'Xem trước (dữ liệu mẫu)',
      save: 'Lưu mẫu',
      saved: 'Đã lưu mẫu thư.',
      revert: 'Về mẫu mặc định',
      close: 'Đóng',
    },
    log: {
      title: 'Thư đã gửi',
      subtitle: 'Mọi thông báo đã gửi hoặc đang chờ gửi, nội dung đã gửi và lý do gửi lỗi.',
      status: 'Trạng thái',
      statuses: {
        PENDING: 'Đang chờ',
        SENDING: 'Đang gửi',
        SENT: 'Đã gửi',
        FAILED: 'Lỗi',
        SUPPRESSED: 'Không gửi (đã tắt)',
        HELD: 'Chờ kết quả Zalo',
        REPLACED: 'Đã gửi qua Zalo (không gửi e-mail)',
      },
      any: 'Tất cả',
      recipient: 'Người nhận',
      search: 'Tìm',
      notice: 'Thông báo',
      to: 'Tới',
      from: 'Từ',
      attempts: 'Số lần thử',
      created: 'Tạo lúc',
      sent: 'Gửi lúc',
      template: 'Mẫu thư',
      empty: 'Chưa có thư',
      first: 'Mới nhất',
      older: 'Cũ hơn',
      detailTitle: 'Thư',
      detailDescription: 'Nội dung đã gửi (liên kết một lần không được lưu).',
      linkNote: 'Thư này có liên kết một lần; liên kết không được lưu trong nhật ký.',
      whatWasSent: 'Nội dung đã gửi',
      resend: 'Gửi lại',
      requeued: 'Đã xếp hàng gửi lại.',
    },
    keys: {
      'layout': 'Khung thư (đầu và chân mọi e-mail)',
      'domain.expiry_reminder': 'Nhắc sắp hết hạn',
      'domain.expired': 'Tên miền đã hết hạn',
      'domain.renewed': 'Đã gia hạn',
      'domain.deleted': 'Tên miền đã bị xoá',
      'transfer.out_requested': 'Có yêu cầu chuyển đi',
      'transfer.out_completed': 'Đã chuyển đi',
      'transfer.in_completed': 'Chuyển về thành công',
      'transfer.code_issued': 'Cấp mã chuyển mới',
      'registrant_change.consent': 'Đổi chủ thể: xin xác nhận',
      'registrant_change.completed': 'Đã đổi chủ thể',
      'registrant_change.rejected': 'Đổi chủ thể bị từ chối',
      'contact.verify_email': 'Xác minh e-mail chủ thể',
      'contact.unverified_suspended': 'Tạm ngưng: chưa xác minh chủ thể',
      'contact.data_reminder': 'Nhắc kiểm tra thông tin hằng năm',
      'abuse.report_received': 'Đã nhận báo cáo lạm dụng',
      'declaration.correction_required': 'Bản khai cần bổ sung',
      'system.test': 'Thư thử',
      'dossier.correction_required': 'Hồ sơ cần bổ sung, chỉnh sửa',
      'domain.registered': 'Đã đăng ký tên miền',
      'dossier.reminder': 'Nhắc bổ sung hồ sơ',
      'billing.payment_received': 'Đã nhận thanh toán',
      'billing.invoice_issued': 'Đã lập hoá đơn',
      'billing.fee_notice': 'Báo phí dịch vụ đến hạn',
      'service.overdue': 'Dịch vụ quá hạn thanh toán',
      'service.suspended': 'Dịch vụ đã bị tạm ngưng',
      'service.terminated': 'Dịch vụ đã bị huỷ',
    },
  },
  routing: {
    tiles: {
      connections: 'Nhà đăng ký & kết nối',
      connectionsHint: '{{direct}} trực tiếp · {{upstream}} qua nhà đăng ký trung gian',
      tlds: 'TLD có kênh đăng ký',
      tldsHint: '{{own}} kênh riêng · {{inherited}} theo mặc định',
      inUse: 'Kết nối đang nhận TLD',
      inUseHint: 'trên {{total}} kết nối đang dùng',
      review: 'Cần rà soát',
      reviewHint: '{{tlds}} TLD qua kết nối chưa sẵn sàng · {{changes}} thay đổi chờ duyệt',
    },
    registrars: {
      title: 'Nhà đăng ký & kết nối',
      description: 'Ai là nhà đăng ký của các tên miền đi qua từng kết nối',
      col: { connection: 'Kết nối', role: 'Vai trò', tlds: 'TLD nhận', status: 'Tình trạng' },
      ready: 'Sẵn sàng',
      notReady: 'Chưa sẵn sàng',
      noTlds: 'Chưa có',
      iana: 'IANA {{id}} · {{name}}',
    },
    matrix: { title: 'Kênh đăng ký mới theo TLD', description: 'Kết nối nhận đăng ký mới và chuyển về của từng TLD' },
    explain: {
      title: 'Giải thích kênh được chọn',
      description: 'Một tên miền mới sẽ đi qua đâu. Không gửi lệnh nào.',
      name: 'Tên miền',
      placeholder: 'vd. tenmien.com.vn',
      run: 'Xem kênh',
      invalid: 'Nhập một tên miền, vd. tenmien.vn',
      noTld: 'Chưa bán đuôi của {{name}}.',
      tld: 'TLD',
      connection: 'Kết nối',
      registry: 'Nhà quản lý',
      registryUnknown: 'Chưa rõ',
      own: 'kênh riêng của TLD',
      inherited: 'theo mặc định',
      notReady: 'Kết nối chưa sẵn sàng: đăng ký mới chưa gửi được.',
      pending: 'Đang chờ duyệt chuyển sang {{name}}.',
      suspended: 'TLD này đang ngừng bán.',
      openTld: 'Mở .{{zone}}',
    },
    noFailover: {
      title: 'Tên miền đang có không tự chuyển sang kết nối khác',
      body: 'Gia hạn, cập nhật và xoá luôn đi qua kết nối đang giữ tên miền. Kênh mới chỉ áp dụng cho đăng ký mới và chuyển về; đổi nhà đăng ký của một tên miền là thủ tục chuyển riêng.',
    },
  },
  support: {
    group: { YES: 'Nhận .{{zone}}', UNKNOWN: 'Chưa xác định được', NO: 'Không nhận .{{zone}}' },
    groupBatch: { YES: 'Nhận mọi TLD đã chọn', UNKNOWN: 'Chưa xác định được với một số TLD', NO: 'Không nhận một số TLD' },
    basis: {
      CURRENT_CHANNEL: 'Đang là kênh của TLD',
      ZONE_DEFAULT: 'Kết nối mặc định của TLD',
      HOLDS_DOMAINS: 'Đang giữ tên miền .{{zone}}',
      IN_PUBLISHED_LIST: 'Có trong danh sách đuôi {{name}} cung cấp',
      NOT_IN_PUBLISHED_LIST: '.{{zone}} không có trong danh sách đuôi {{name}} cung cấp',
      LIST_UNAVAILABLE: 'Chưa đọc được danh sách đuôi của {{name}}',
      NO_PUBLISHED_LIST: '{{name}} không công bố danh sách đuôi',
      VNNIC_ZONE: 'VNNIC nhận các đuôi .vn',
      VNNIC_ONLY_VN: 'VNNIC chỉ nhận đuôi .vn',
      OPERATOR_UNKNOWN: 'Chưa rõ nhà quản lý của .{{zone}}',
      NOT_DECLARED: 'Chưa nhận TLD nào nên chưa biết thuộc nhà quản lý nào',
      SAME_OPERATOR: 'Cùng nhà quản lý với các TLD kết nối đang nhận',
      OTHER_OPERATOR: 'Kết nối của nhà quản lý khác ({{operators}})',
    },
    unknownHint: 'Vẫn chọn được; sau khi đổi, dùng “Thử kiểm tra một tên” trên trang TLD.',
    loading: 'Đang xem kết nối nào nhận TLD này…',
    failed: 'Không xem được kết nối nào nhận TLD này; đang hiện mọi kết nối.',
    batchMissing: 'Không nhận: {{list}}',
    batchUnknown: 'Chưa xác định: {{list}}',
    showHidden: 'Xem {{count}} kết nối không nhận',
    hideHidden: 'Ẩn các kết nối không nhận',
  },
  health: {
    summary: '{{ready}} sẵn sàng · {{attention}} cần chú ý',
    summaryHint: 'Mỗi kết nối có hàng đợi, giới hạn tốc độ và bộ ngắt riêng',
    state: { READY: 'Sẵn sàng', NOT_READY: 'Chưa sẵn sàng', TEST_FAILED: 'Lần kiểm tra gần nhất không đạt', SUSPENDED: 'Tạm ngừng', RETIRED: 'Ngừng dùng', NOT_CONFIGURED: 'Chưa cấu hình' },
    commands: 'Lệnh {{hours}} giờ qua',
    slowest: 'Chậm nhất',
    unresolved: 'Chưa rõ kết quả',
    balance: 'Số dư tại nhà cung cấp',
    balanceError: 'Chưa hỏi được',
    certificate: 'Chứng thư số',
    certificateDays: 'Còn {{count}} ngày',
    noCertificate: 'Chưa có',
    lastTest: 'Kiểm tra gần nhất',
    noZones: 'Chưa nhận TLD nào',
    moreZones: '+{{count}}',
    detail: 'Chi tiết',
    recent: {
      title: 'Lệnh gần đây',
      description: 'Lệnh gửi tới nhà quản lý và nhà đăng ký trung gian, không kèm dữ liệu cá nhân',
      open: 'Mở nhật ký lệnh',
      empty: 'Chưa có lệnh nào.',
      hidden: 'Cần quyền xem lệnh registry.',
      col: { at: 'Lúc', connection: 'Kết nối', command: 'Lệnh', object: 'Tên', result: 'Kết quả' },
    },
    attention: {
      title: 'Việc cần chú ý',
      description: 'Kiểm tra kết nối không thay cho kết quả của từng lệnh',
      certificates: 'Chứng thư số sắp hết hạn',
      certificatesHint: 'Dưới 30 ngày: {{list}}',
      notReady: 'Kết nối chưa sẵn sàng',
      notReadyHint: '{{list}}',
      unresolved: 'Lệnh chưa rõ kết quả',
      unresolvedHint: 'Chờ đối soát',
      drift: 'Sai lệch với nhà quản lý',
      driftHint: 'Mục đối soát đang mở',
      messages: 'Tin nhắn của nhà quản lý chưa xử lý',
      messagesHint: 'Thông báo nhà quản lý gửi về',
      changes: 'Thay đổi chờ duyệt',
      changesHint: 'Trên các kết nối ở trên',
      none: 'Không có việc cần chú ý.',
    },
    breaker: {
      title: 'Mỗi kết nối tự ngắt khi lỗi liên tiếp',
      body: 'Lỗi nhiều lần liên tiếp thì kết nối tạm ngừng gửi lệnh một lúc rồi thử lại; các kết nối khác không bị ảnh hưởng. Đăng ký mới đi theo kênh của TLD; tên miền đang có đi qua kết nối đang giữ nó.',
    },
    explainTitle: 'Kết nối và kênh đăng ký là gì?',
  },
  connectionTiles: {
    tlds: 'TLD nhận',
    tldsHint: '{{own}} kênh riêng · {{inherited}} theo mặc định',
    domains: 'Tên miền đang giữ',
    changes: 'Thay đổi chờ duyệt',
    lastTest: 'Kiểm tra gần nhất',
    certificate: 'Chứng thư số',
  },
};
